/* Aurum Galerie · yayın katmanı (21 Ekim 2026) — her parça kendi try/catch'inde.
   Kaynak: aurum-galerie/katman/; derleyen: araclar/katman_derle.py
   Parçalar: ceviriler.json, aa-dil.js, ana-slider-gecis.js, ana-v1.js, defne-rozeti.js, galeri-ok.js, gg-footer.js, header-altin.js, hiz.js, imza-bosluk.js, kaydir-otomatik.js, kaydir-surukle.js, sayfa-animasyon.js, sepet-odeme.js, zz-ana-sayfa-kaide.js */

/* ==== ceviriler.json ==== */
window.ggSozluk = {"secici.galeri_onceki":{"tr":"Önceki görsel","en":"Previous image","ja":"前の画像","de":"Vorheriges Bild","fr":"Image précédente","es":"Imagen anterior","it":"Immagine precedente","ru":"Предыдущее изображение","ar":"الصورة السابقة","zh-CN":"上一张图片"},"secici.galeri_sonraki":{"tr":"Sonraki görsel","en":"Next image","ja":"次の画像","de":"Nächstes Bild","fr":"Image suivante","es":"Imagen siguiente","it":"Immagine successiva","ru":"Следующее изображение","ar":"الصورة التالية","zh-CN":"下一张图片"},"secici.odeme_yontemleri":{"tr":"Ödeme yöntemleri","en":"Payment methods","ja":"お支払い方法","de":"Zahlungsarten","fr":"Moyens de paiement","es":"Métodos de pago","it":"Metodi di pagamento","ru":"Способы оплаты","ar":"طرق الدفع","zh-CN":"付款方式"}};

/* ==== aa-dil.js ==== */
try {
/* 59) Dil ve adres: katmanın ortak yardımcısı (9 Ekim). Sahibi: "tarayıcı diline göre dil değiştirme ... düzelt, bir daha yaşamayalım; çevirisini de yap".
   Sitenin yabancı dil sayfalarının adresi dil önekiyle başlar (/en/products/lale, /zh/pages/atolye) ve sayfadaki iç bağlantılar da öneklidir.
   Eskiden katmanın sayfa denetimleri öneki tanımıyordu: yabancı dil sayfalarında ana sayfa tasarımı, İncelikle, ürün galerisi çalışmıyordu.
   Artık katmandaki bütün sayfa denetimleri, bağlantılar ve ziyaretçiye giden metinler buradan alınır (derle.py, katmanda location.pathname'i
   yalnız bu dosyada kabul eder; başka yerde kullanılırsa paket üretilmez):
     ggDil.kod       sayfanın dili (tr, en, ja, de, fr, es, it, ru, ar, zh-CN) — tema <head>'deki window.GG.localization'dan
     ggDil.kok       dilin adres kökü ('' Türkçe, '/en', '/zh' …; pazara göre '/en-gb' gibi de olabilir)
     ggDil.yol       öneksiz yol ('/', '/products/lale', '/pages/atolye' …) — sayfa denetimleri bununla yapılır
     ggDil.url(p)    öneksiz iç adres → bu dildeki adres ('/pages/atolye' → '/en/pages/atolye')
     ggDil.t(k, v)   çeviri: ceviri/ceviriler.json'daki anahtar (derle.py pakete window.ggSozluk olarak gömer); {ad} gibi yer tutucular v'den.
                     Dilde yoksa İngilizce, o da yoksa Türkçe.
     ggDil.rtl       sağdan sola mı (ar) */
(() => {
  const G = window.GG || {}, L = G.localization || {};
  const diller = Array.isArray(L.languages) ? L.languages : [];
  const kod = L.language || (document.documentElement.getAttribute('lang') || 'tr');
  const p = location.pathname;
  // dilin kökü: önce sayfanın kendi dili, yoksa adresin başındaki bilinen kök
  const kokOf = (d) => String((d && d.root) || '').replace(/\/+$/, '');
  let kok = kokOf(diller.find((d) => d.code === kod));
  if (!kok) for (const d of diller) { const k = kokOf(d); if (k && (p === k || p.startsWith(k + '/'))) { kok = k; break; } }
  const yol = kok && (p === kok || p.startsWith(kok + '/')) ? (p.slice(kok.length) || '/') : p;
  const S = window.ggSozluk || {};
  const eksik = new Set();
  // t(anahtar, değişkenler, yedek): sözlükte yoksa yedek (dosyadaki Türkçe metin) kullanılır
  const t = (anahtar, v, yedek) => {
    const s = S[anahtar];
    let m = s ? (s[kod] || s.en || s.tr || '') : '';
    if (!m) {
      m = yedek != null ? String(yedek) : anahtar;
      if (kod !== 'tr' && !eksik.has(anahtar)) { eksik.add(anahtar); console.warn('gg-dil: çeviri yok →', anahtar, '(' + kod + ')'); }   // bir daha yaşanmasın: fark edilsin
    }
    if (v) for (const x in v) m = m.split('{' + x + '}').join(v[x]);
    return m;
  };
  const url = (u) => (typeof u === 'string' && u.charAt(0) === '/' && u.charAt(1) !== '/' && kok && !(u === kok || u.startsWith(kok + '/')) ? kok + u : u);
  const rtl = document.documentElement.getAttribute('dir') === 'rtl' || /^(ar|he|fa|ur)\b/.test(kod);
  window.ggDil = { kod, kok, yol, url, t, rtl, birincil: kod === (L.primary || 'tr') };
})();

} catch (e) { console.error("gg-yayin: aa-dil.js", e); }

/* ==== ana-slider-gecis.js ==== */
try {
/* 50) Ana sayfa üst görsel (slider) geçişi — sahibinin isteği: "kaydırma ve geçiş efekti kötü duruyor, özellikle telefonda; daha smooth bir geçiş".
   Sitede yeni slayt ~1,5 sn'de kayarak ve büyüyerek geliyor, eski slayt öbür yöne kayıyor, iki slaytın yazıları üst üste biniyordu.
   (8 Ekim) Çapraz geçiş: yeni slayt eskisinin üstünde 0,9 sn'de belirir; telefonda görsel parmağı en çok 48 px izler.
   26 Ekim 2026 (sahibi: "ana sayfadaki ilk görsellerdeki kaydırma efekti çok kötü, smooth bir geçiş olsun"): parmakla çizilen hareket ile
   ekrandaki hareket uyuşmuyordu (görsel 48 px kıpırdayıp yerine dönüyor, yeni görsel üstüne soluklaşarak çıkıyordu). Yeni geçiş, telefon
   galerisi gibi:
   - kaydırırken görsel parmağı birebir izler, yanında sıradaki (ya da önceki) slaytın görseli görünür;
   - bırakınca (site 60 px ya da hızlı fiskeyle geçer) iki görsel birlikte, kaldıkları yerden yumuşakça kayar (0,76 sn, yavaşlayarak durur);
     geçilmediyse görsel yerine süzülür;
   - kendiliğinden geçişte ve noktalarla geçişte aynı kayma (ileri: sağdan gelir; geri: soldan).
   Eski slaytın yazıları hemen silinir, yenileri onaylı tek yazı animasyonuyla gelir (ana-v1.js). Kayma yalnız translate ile (ekran kartı
   yürütür). Hareket azaltma açıksa geçiş anında olur, görsel parmağı izlemez. */
(() => {
  if ((window.ggDil ? window.ggDil.yol : location.pathname) !== '/') return;   // dil önekli ana sayfa da (/en) — aa-dil.js
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ADA = '[data-island="HomeSlider"]';
  const KAT = ADA + ' div.relative.isolate > div.relative.h-full';   // her slayt bir katman (geçişte ikisi üst üste); kartın doğrudan çocuğu
  const YAZI = 'div.relative.mx-auto.flex.h-full';               // slaytın yazı bloğu
  const SURE = 760, EGRI = 'cubic-bezier(.22,.8,.24,1)';

  // Sitenin slaytı hareketini tarayıcının animasyon motoruyla (WAAPI) yapıyor; katmanın kendisinde ona "!important" ile üstün gelinir
  // (kayma, büyüme, solma iptal). Bizim kaymamız translate özelliğiyle (transform'dan bağımsız).
  const css = document.createElement('style');
  css.textContent = `
${KAT} { opacity: 1 !important; transform: none !important; translate: var(--gg-sl-x, 0px) 0; touch-action: pan-y; user-select: none; -webkit-user-select: none; cursor: grab; }
${KAT}.gg-sl-surukle { cursor: grabbing; }
${KAT}.gg-sl-geri { transition: translate .45s cubic-bezier(.22,1,.36,1); }
${KAT}.gg-sl-gir { animation: ggSlGir ${SURE}ms ${EGRI} both; }
${KAT}.gg-sl-cik { animation: ggSlCik ${SURE}ms ${EGRI} both; }
@keyframes ggSlGir { from { translate: var(--gg-sl-gbas, 100%) 0; } to { translate: 0 0; } }
@keyframes ggSlCik { from { translate: var(--gg-sl-cbas, 0px) 0; } to { translate: var(--gg-sl-cbit, -100%) 0; } }
${KAT} ${YAZI} { opacity: 1 !important; transform: none !important; }
${KAT}.gg-sl-eski ${YAZI} { opacity: 0 !important; transition: opacity .25s ease; }
.gg-sl-peek { position: absolute; inset: 0; z-index: 2; pointer-events: none; overflow: hidden; translate: var(--gg-sl-px, 100%) 0; }
.gg-sl-peek.gg-sl-geri { transition: translate .45s cubic-bezier(.22,1,.36,1); }
.gg-sl-peek > * { position: absolute !important; inset: 0 !important; }
@media (prefers-reduced-motion: reduce) { ${KAT}.gg-sl-gir, ${KAT}.gg-sl-cik { animation: none; } ${KAT} { translate: none; } .gg-sl-peek { display: none; } }`;
  document.head.appendChild(css);

  // Sıradaki slaytın görseli (kaydırırken yanda görünen): sayfanın ilk hâlindeki (adacıktan önceki) slaytların kopyası, yazısız. Görsel
  // adresleri adacığınkiyle aynı, tarayıcı aynı dosyayı seçer; görsel adacıkta da hazır olur.
  const onizler = [...document.querySelectorAll(ADA + ' [id^="GgSlide-"]')].map((s) => {
    const c = s.cloneNode(true);
    c.removeAttribute('id');
    c.querySelectorAll('div.max-w-7xl, form, a, button').forEach((x) => x.remove());
    c.querySelectorAll('img').forEach((i) => { i.removeAttribute('fetchpriority'); i.setAttribute('loading', 'eager'); i.setAttribute('alt', ''); });
    c.setAttribute('aria-hidden', 'true');
    return c;
  });

  const zi = (k) => parseInt(k.style.zIndex || '0', 10) || 0;
  const ust = () => { const ks = [...document.querySelectorAll(KAT)]; let c = ks[0]; ks.forEach((k) => { if (zi(k) >= zi(c)) c = k; }); return c; };
  const noktalar = () => [...document.querySelectorAll(ADA + ' button.min-w-6')];
  const sira = () => noktalar().findIndex((b) => b.getAttribute('aria-current') === 'true');
  const kart = () => { const k = document.querySelector(KAT); return k && k.parentElement; };

  /* ---- kaydırırken yandaki görsel ---- */
  let peek = null, peekYon = 0;
  const peekKur = (yon) => {
    const n = onizler.length;
    if (!n) return null;
    if (peek && peekYon === yon) return peek;
    const k = kart();
    if (!k) return null;
    const i = ((sira() + yon) % n + n) % n;
    if (!peek) { peek = document.createElement('div'); peek.className = 'gg-sl-peek'; }
    peek.replaceChildren(onizler[i].cloneNode(true));
    peek.classList.remove('gg-sl-geri');
    if (peek.parentElement !== k) k.appendChild(peek);
    peekYon = yon;
    return peek;
  };
  const peekKaldir = (geri) => {
    if (!peek) return;
    const p = peek;
    peek = null; peekYon = 0;
    if (!geri) { p.remove(); return; }
    p.classList.add('gg-sl-geri');
    p.style.setProperty('--gg-sl-px', (p._yon > 0 ? '100%' : '-100%'));
    setTimeout(() => p.remove(), 480);
  };

  /* ---- geçiş: katman değişince ---- */
  let aktif = null, aktifSira = -1, birakis = null;
  const isle = () => {
    const kats = [...document.querySelectorAll(KAT)];
    if (!kats.length) return;
    const cur = ust();
    kats.forEach((k) => {
      if (k === cur || k.classList.contains('gg-sl-eski')) return;
      k.classList.remove('gg-sl-gir', 'gg-sl-geri', 'gg-sl-surukle');
      k.classList.add('gg-sl-eski');
    });
    cur.classList.remove('gg-sl-eski');
    if (aktif === null) { aktif = cur; aktifSira = sira(); return; }   // ilk açılış: geçiş yok
    if (cur === aktif) return;
    const eski = aktif, yeniSira = sira(), n = noktalar().length || 1;
    // yön: parmakla geçildiyse parmağın yönü; değilse kısa yol (ileri +1: sağdan gelir)
    let yon, dx = 0;
    if (birakis && performance.now() - birakis.t < 600) { yon = birakis.yon; dx = birakis.dx; }
    else if (x0 !== null && son) { yon = son < 0 ? 1 : -1; dx = son; x0 = null; kat = null; }   // parmak dururken başka yerden geçildi
    else yon = ((yeniSira - aktifSira + n) % n) <= n / 2 ? 1 : -1;
    birakis = null;
    aktif = cur; aktifSira = yeniSira;
    if (RM) { peekKaldir(false); return; }
    eski.classList.remove('gg-sl-gir', 'gg-sl-geri', 'gg-sl-surukle');
    eski.style.setProperty('--gg-sl-cbas', dx + 'px');
    eski.style.setProperty('--gg-sl-cbit', (-yon * 100) + '%');
    eski.classList.remove('gg-sl-cik');
    cur.classList.remove('gg-sl-gir', 'gg-sl-cik', 'gg-sl-geri', 'gg-sl-surukle');
    cur.style.setProperty('--gg-sl-x', '0px');
    cur.style.setProperty('--gg-sl-gbas', `calc(${yon * 100}% + ${dx}px)`);
    void cur.offsetWidth;   // animasyonlar baştan başlasın
    eski.classList.add('gg-sl-cik');
    cur.classList.add('gg-sl-gir');
    requestAnimationFrame(() => peekKaldir(false));   // yeni katman yandaki görselin yerini aldı
    clearTimeout(cur._ggSl);
    cur._ggSl = setTimeout(() => cur.classList.remove('gg-sl-gir'), SURE + 60);
  };

  /* ---- kaydırma: görsel parmağı (fareyi) birebir izler; geçişe slaytın kendisi karar verir (60 px ya da hızlı fiske) ---- */
  let x0 = null, y0 = 0, yatay = null, kat = null, son = 0, iz = [];
  const bas = (e) => {
    if (RM || !e.target.closest(ADA) || e.target.closest('button, a, input, select')) return;
    const k = ust();
    if (!k || !k.contains(e.target)) return;
    x0 = e.clientX; y0 = e.clientY; yatay = null; kat = k; son = 0; iz = [[e.clientX, performance.now()]];
  };
  const tasi = (e) => {
    if (x0 === null || !kat) return;
    const dx = e.clientX - x0, dy = e.clientY - y0;
    iz.push([e.clientX, performance.now()]);
    if (iz.length > 6) iz.shift();
    if (yatay === null && Math.hypot(dx, dy) > 6) yatay = Math.abs(dx) > Math.abs(dy);
    if (!yatay) return;
    const w = kat.offsetWidth || 1;
    son = Math.max(-w, Math.min(w, dx));
    kat.classList.remove('gg-sl-geri');
    kat.classList.add('gg-sl-surukle');
    kat.style.setProperty('--gg-sl-x', son + 'px');
    const yon = son < 0 ? 1 : -1;   // sola çekince sıradaki
    const p = Math.abs(son) > 1 ? peekKur(yon) : null;
    if (p) { p._yon = yon; p.style.setProperty('--gg-sl-px', `calc(${yon * 100}% + ${son}px)`); }
  };
  const birak = () => {
    if (x0 === null) return;
    const k = kat, dx = son;
    x0 = null; kat = null;
    if (!k || !yatay || !dx) { peekKaldir(true); return; }
    birakis = { t: performance.now(), dx, yon: dx < 0 ? 1 : -1 };
    // 60 px'ten uzun ya da hızlı (500 px/sn) kaydırmada geçilir (sitenin eski sürükleme eşikleri, carousel.tsx SWIPE_*): sıradaki ya da
    // önceki slaytın noktası tıklanır; görsel yeni slayt gelene kadar yerinde bekler, gelince ikisi birlikte kayar. Kısa ve yavaşsa yerine
    // süzülür. Geçiş olmazsa (ör. tek slayt) 0,7 sn sonra yine yerine döner.
    const a = iz[0], b = iz[iz.length - 1];
    const hiz = a && b && b[1] > a[1] ? ((b[0] - a[0]) / (b[1] - a[1])) * 1000 : 0;
    const gecer = Math.abs(dx) > 60 || (Math.abs(hiz) > 500 && Math.sign(hiz) === Math.sign(dx));
    const ns = noktalar();
    if (gecer && ns.length > 1) ns[((sira() + birakis.yon) % ns.length + ns.length) % ns.length].click();
    setTimeout(() => {
      if (aktif !== k) return;
      birakis = null;
      k.classList.remove('gg-sl-surukle');
      k.classList.add('gg-sl-geri');
      k.style.setProperty('--gg-sl-x', '0px');
      peekKaldir(true);
    }, gecer ? 700 : 0);
  };
  addEventListener('pointerdown', bas, { passive: true });
  addEventListener('pointermove', tasi, { passive: true });
  addEventListener('pointerup', birak, { passive: true });
  addEventListener('pointercancel', birak, { passive: true });

  // katmanlar eklenip çıkarıldıkça ve site z-index'i değiştirdikçe yeniden hesapla (yalnız slayt adasında)
  let gozcu = null, bekle = false;
  const iste = () => { if (!bekle) { bekle = true; queueMicrotask(() => { bekle = false; isle(); }); } };
  const bagla = () => {
    const ada = document.querySelector(ADA);
    if (!ada || ada === gozcu) return;
    gozcu = ada;
    new MutationObserver(iste).observe(ada, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    iste();
  };
  bagla();
  new MutationObserver(bagla).observe(document.body, { childList: true, subtree: true });
})();

} catch (e) { console.error("gg-yayin: ana-slider-gecis.js", e); }

/* ==== ana-v1.js ==== */
try {
/* Ana sayfa · varyasyon 1 "Yazı sahnesi" (önizleme, 8 Ekim · sahibinin seçtiği varyasyon, düzeltmeler işlendi).
   Aurum Galerie (21 Ekim 2026): satranç taşları yerine logodaki altın "A" (aşağıda PIECES). GG metni:
   Fikir: bölümler bir dergi sayfası gibi sıralanır. Her bölüm başlığının üstünde, iki yanında kendini çizen ince altın çizgilerle bir satranç taşı;
   taşlar sayfa aşağı indikçe değer kazanır: piyon (Dersaadet Koleksiyonu) → at (Ustamız) → fil (Yakından) → kale (Sorularınız) → vezir (Atölyeden haber).
   Bütün yazılar TEK bir animasyonla gelir: kelime kelime, bulanıktan nete ve hafifçe yukarı (aynı süre, aynı eğri, aynı kelime arası).
   Ürün adları (üst görsel + dört kart) yazılırken her çizgi, ürün sayfasındaki gibi altın ışıkla parlayıp sakinleşir.
   Yazıların hepsi sitenin kendi metni; yeni metin yok (yalnız "Yakından" kartlarındaki etiketlerin oku, etiket sabitine uymak için gizli).

   ONAYLI (8 Ekim, sahibi: "1 güzel, buradan devam edeceğiz"): ana sayfanın varsayılan tasarımı. Karşılaştırma için ?ana=0 eski hâli gösterir.
   Bütün kurallar html.gg-ana-v1 altında.
   Hareket azaltma açıksa hiçbir şey hareket etmez: yazılar, taşlar ve çizgiler sabit ve tam görünür; ışıltı yok.

   21st.dev bileşenleri (React/Motion kaynakları düz JS + CSS'e çevrildi):
   - Blur Reveal — tom_ui — https://21st.dev/@tom_ui/components/blur-reveal
     Bütün yazıların tek animasyonu; kelime birimine uygulandı: opaklık 0, blur 12px, y 10px → net; süre 0,6 sn; kelime arası 0,06 sn.
   - Apple Hello Effect — ncdai — https://21st.dev/@ncdai/components/apple-hello-effect
     Taşların iki yanındaki altın çizgiler kendini çizer (pathLength 0 → 1, ease-in-out). Sitenin el yazısı adları da bu yöntemle çiziliyor;
     "N. Sayın" imzası başlık ekrana girince baştan çizilir.
   - Işıltı: ürün sayfasındaki yazı ışığının aynısı (yakut-yazi-isik.js / onizleme.css madde 14: 21st "Glow Text Reveal", @hyperiux, glowing-char-reveal):
     her çizgi yazılırken drop-shadow 7/18/34px rgba(246,231,195,.63), süre = çizginin süresi + 0,5 sn, gecikme = çizginin başlangıcı.
   (İlk sürümdeki Slide Up Text ve Gradual Spacing, "tek animasyon" isteğiyle kaldırıldı.)

   9 Ekim (sahibi: "ana sayfadaki yazı animasyonlarını, diğer animasyonları da diğer sayfalara aynı şekilde yap"): bu dosyanın ORTAK parçası
   (tek animasyon, altın kelimeler, satranç taşı başlık işareti, ürün adı ışıltısı) artık her sayfada kurulur ve window.ggAna ile açılır;
   ana sayfaya özel bölümler yalnız ana sayfada çalışır. Ortak kurallar html.gg-v1, ana sayfanınkiler html.gg-ana-v1 altında; ana sayfada
   ikisi birden olduğu için ana sayfanın görünüşü değişmedi. Öteki sayfaları sayfa-animasyon.js işler. */
(() => {
  const ANA = (window.ggDil ? window.ggDil.yol : location.pathname) === '/';   // dil önekli ana sayfa da (/en, /de …) — aa-dil.js
  if (ANA && new URLSearchParams(location.search).get('ana') === '0') return;   // karşılaştırma: eski ana sayfa

  const root = document.documentElement;
  root.classList.add('gg-v1');
  if (ANA) root.classList.add('gg-ana-v1');
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!RM) root.classList.add('v1-m');

  /* tek animasyonun ölçüleri (her yerde aynı) */
  const DUR = 600, STAGGER = 60, BATCH = 120, EASE = 'cubic-bezier(.25,.1,.35,1)';

  const G = 'html.gg-v1';       // ortak: bütün sayfalar
  const H = 'html.gg-ana-v1';   // yalnız ana sayfa
  const css = document.createElement('style');
  css.id = 'gg-ana-v1-css';
  css.textContent = `
${G} .v1-wd{display:inline-block}
/* sağdan sola (ar) ve boşluksuz yazıda (ja, zh) kelime kutusu satır içi: inline-block, sağdan sola sayfada birden çok Latin kelimenin
   sırasını ters çevirir ("Dersaadet Koleksiyonu" → "Koleksiyonu Dersaadet"), boşluksuz cümleyi tek kutu yapar. Bu dillerde hafif yukarı
   kayma yok; bulanıktan nete gelme aynı. */
html.gg-v1:is([dir="rtl"],:lang(ja),:lang(zh)) .v1-wd:not(svg){display:inline}
${G} .v1-gold{background-image:var(--v1-g,var(--gg-altin-capraz));background-repeat:no-repeat;-webkit-background-clip:text;background-clip:text;color:transparent;-webkit-text-fill-color:transparent}

/* TEK animasyon: kelime kelime bulanıktan nete, hafifçe yukarı (Blur Reveal) */
${G}.v1-m .v1-t .v1-wd{opacity:0;filter:blur(12px);transform:translateY(10px);transition:opacity ${DUR}ms ${EASE},filter ${DUR}ms ${EASE},transform ${DUR}ms ${EASE};transition-delay:calc((var(--b,0) + var(--d,0)) * 1ms)}
${G}.v1-m .v1-t.v1-in .v1-wd{opacity:1;filter:blur(0);transform:none}
${G}.v1-m .v1-t.v1-done .v1-wd{filter:none;transition:none}
${G}.v1-m .v1-t.v1-done .v1-wd:not(.v1-gold):not(svg){display:inline}
/* sitenin kendi yazı kutusu hareketleri kapalı: her yazının yalnız bu tek hareketi olsun */
${H} [id$="__slider"] .gg-island div.relative.mx-auto.flex.h-full,
${H} [id$="__artisan_arc"] .gg-island div.relative.mx-auto.max-w-7xl,
${H} [id$="__globe"] .gg-island div.relative.z-10.mx-auto{opacity:1!important;transform:none!important}
/* işlenmeden önce yazılar görünüp kaybolmasın (6 sn güvenlik süresi var) */
${H}.v1-m .v1-pend .gg-island :is(h2,h3,p),${H}.v1-m .v1-pend .gg-island div.relative.mx-auto.flex.h-full > span{opacity:0}

/* başlık: daha geniş yazı ölçeği */
${H} main h2.v1-h{font-size:clamp(38px,4.2vw + 20px,64px)!important;line-height:1.04!important;letter-spacing:-.012em!important;text-wrap:balance}
/* "Ustamız" + imza tek satırda kalsın (imza yazının ~6,7 katı genişlikte): sütun genişliğine göre */
${H} main [id$="__artisan_arc"] h2.v1-h{font-size:min(44px,calc((100vw - 32px) / 10.8))!important}
@media (min-width:768px){${H} main [id$="__artisan_arc"] h2.v1-h{font-size:min(46px,calc((100vw - 64px) / 10.8))!important}}
@media (min-width:1024px){${H} main [id$="__artisan_arc"] h2.v1-h{font-size:min(44px,calc(3.9vw - 6px))!important}}

/* başlık üstü: altın satranç taşı + iki yanında kendini çizen ince altın çizgi (her sayfa; öteki sayfalarda h1 başlıklarda da) */
${G} .v1-kick{display:flex;align-items:center;justify-content:center;gap:14px;margin:0 0 14px;line-height:1;letter-spacing:0}
${G} .v1-kick[data-al="start"]{justify-content:flex-start}
${G} .v1-kick[data-al="start"] .v1-ln-l{display:none}
@media (min-width:1024px){${G} .v1-kick[data-al="lgstart"]{justify-content:flex-start}${G} .v1-kick[data-al="lgstart"] .v1-ln-l{display:none}}
${G} main :is(h1,h2) .v1-kick svg.v1-pc{display:block;flex:none;overflow:visible;color:inherit}
${G} main :is(h1,h2) .v1-kick svg.v1-ln{display:block;flex:none;width:48px;height:2px;overflow:visible;color:oklch(.80 .075 80 / .7)}
${G} .v1-ln path{fill:none;stroke:currentColor;stroke-width:1;stroke-linecap:round;stroke-dasharray:1 1;stroke-dashoffset:0}
${G}.v1-m .v1-kick .v1-ln path{stroke-dashoffset:1;opacity:0;transition:stroke-dashoffset .8s cubic-bezier(.42,0,.58,1) .1s,opacity .4s cubic-bezier(.42,0,.58,1) .1s}
${G}.v1-m .v1-in .v1-kick .v1-ln path{stroke-dashoffset:0;opacity:1}
/* sağdan sola sayfalarda (Arapça) çizgiler yine taştan dışa doğru çizilsin */
${G}[dir="rtl"] .v1-kick svg.v1-ln{transform:scaleX(-1)}

/* Dersaadet Koleksiyonu: fiyat fiyat sabitinde (Fraunces, altın ışık), renk adı gümüş; başlık etiketinin altın ışığı kelimelerde */
${H} [id$="__tiles"] [data-slot="product-card-metric"]{font-family:Fraunces,Georgia,serif!important;font-size:18px!important;font-variant-numeric:lining-nums tabular-nums}
@media (min-width:768px){${H} [id$="__tiles"] [data-slot="product-card-metric"]{font-size:20px!important}}
${H} [id$="__tiles"] [data-slot="product-card-subtitle"]{color:var(--gg-gumus)!important;letter-spacing:.02em}
${H} [id$="__tiles"] a.v1-gl span.underline{display:inline!important}

/* Ustamız N. Sayın */
${H} [id$="__artisan_arc"] h2.v1-h ~ * p.v1-t,${H} [id$="__artisan_arc"] div.lg\\:col-span-5 + div > p.v1-t{font-size:18px;line-height:1.6}

/* Yakından: kart başlıkları büyük; alttaki bağlantılar altın gezinme etiketi (oksuz) */
${H} [id$="__promo"] h3.v1-hs{font-family:var(--gg-baslik-font)!important;font-weight:600!important;font-size:28px!important;line-height:1.08!important;letter-spacing:-.005em}
@media (min-width:768px){${H} [id$="__promo"] h3.v1-hs{font-size:32px!important}}
${H} [id$="__promo"] .v1-cta{margin-top:14px!important;font-size:11px!important;font-weight:600!important;letter-spacing:.18em!important;line-height:1.2!important;text-transform:uppercase;color:transparent!important}
${H} [id$="__promo"] .v1-cta > svg{display:none}

/* Sorularınız: ince altın çizgiler; soru numarası yok (sahibi rakamla sıralamayı istemedi) */
${H} [id$="__faq"] div.border-t{counter-reset:v1q;border-color:oklch(.80 .075 80 / .3)!important}
${H} [id$="__faq"] div.border-t > div.border-b{counter-increment:v1q;border-color:oklch(.80 .075 80 / .16)!important}
${H} [id$="__faq"] div.border-t > div > h3 > button{justify-content:flex-start!important;align-items:baseline!important;column-gap:12px;font-family:var(--gg-baslik-font)!important;font-weight:600!important;font-size:23px!important;line-height:1.2!important;color:var(--color-gg-ivory,#f7f3ea)}
${H} [id$="__faq"] div.border-t > div > h3 > button::before{content:none!important;display:none!important}
${H} [id$="__faq"] div.border-t > div > h3 > button > span.v1-qt{flex:1 1 auto;min-width:0}
${H} [id$="__faq"] div.border-t > div > h3 > button > svg{margin-inline-start:auto;align-self:center;flex:none}
${H} [id$="__faq"] div.border-t > div > [role="region"]{padding-inline-start:0}
@media (min-width:768px){${H} [id$="__faq"] div.border-t > div > h3 > button{font-size:26px!important}}

/* Atölyeden haber */
${H} [id$="__newsletter"] h2.v1-h + p.v1-t{font-size:16px;max-width:34ch}

/* ürün adlarında ışıltı (her sayfa): her çizgi ayrı katmanda, yazılırken altın ışıkla parlar. Ürün kartı adının kutusu ışığı kesmesin. */
${G} .v1-ggt{position:absolute;left:0;top:0;pointer-events:none;--glow-hard:rgba(246,231,195,.63)}
${G} .v1-ggt > svg{position:absolute;inset:0;width:100%;height:100%;overflow:visible;display:block}
${G} .v1-ggp > svg:has(+ .v1-ggt){visibility:hidden}
${G} main [data-slot="product-card-title"]{overflow:visible!important}
@keyframes v1-glow{0%{filter:none}55%{filter:drop-shadow(0 0 7px var(--glow-hard)) drop-shadow(0 0 18px var(--glow-hard)) drop-shadow(0 0 34px var(--glow-hard))}100%{filter:none}}

@media (prefers-reduced-motion:reduce){
  ${G} .v1-wd,${G} .v1-ln path{transition:none!important;opacity:1!important;filter:none!important;transform:none!important;stroke-dashoffset:0!important}
}
`;
  document.head.appendChild(css);

  /* ---- yardımcılar ---- */
  const mk = (tag, cls, txt) => { const e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; };
  const NS = 'http://www.w3.org/2000/svg';
  const svgEl = (tag, attrs) => { const e = document.createElementNS(NS, tag); for (const k in attrs) e.setAttribute(k, attrs[k]); return e; };

  // ince altın çizgi (Apple Hello yöntemi: pathLength 1, dashoffset 1 → 0)
  const line = (side) => {
    const s = svgEl('svg', { class: 'v1-ln v1-ln-' + side, viewBox: '0 0 48 2', preserveAspectRatio: 'none', 'aria-hidden': 'true', focusable: 'false' });
    s.appendChild(svgEl('path', { d: side === 'l' ? 'M48 1H0' : 'M0 1H48', pathLength: '1' }));   // taştan dışa doğru çizilir
    return s;
  };

  // Aurum Galerie (21 Ekim 2026): satranç taşlarının yerine logodaki altın "A" (Cormorant Garamond 600; marka/aurum-yazi.json).
  // Anahtarlar (piyon, at, fil, kale, vezir) korunur, hepsi aynı işareti verir; boy 22–27 px yerine tek boy 22 px.
  // Işık header-altin.js'teki #ggAltinCapraz ile aynı duraklar ve yön; her işaretin kendi kopyası (bütününe tek geçiş).
  // 21 Ekim 2026 (sahibi: "A yazıyor, basit ve kötü gözüküyor"; logo yazı olunca seçenek A "İnce çizgi ve elmas"): işaret küçük altın
  // eşkenar dörtgen; iki yanındaki ince çizgileri bu dosya zaten çiziyor. marka/secenekler/logotip/sus/a-elmas/sus.svg ile aynı oran.
  const A_YOL = 'M50 0L86 50L50 100L14 50Z';
  const A_VB = '0 0 100 100';
  const PIECES = { piyon: { ad: 'A', h: 13 }, at: { ad: 'A', h: 13 }, fil: { ad: 'A', h: 13 }, kale: { ad: 'A', h: 13 }, vezir: { ad: 'A', h: 13 } };
  let pieceN = 0;
  const piece = (key) => {
    const p = PIECES[key] || PIECES.piyon, id = 'v1-altin-' + (++pieceN);
    const w = (p.h * 100 / 100).toFixed(2);
    const s = document.createElementNS(NS, 'svg');
    s.setAttribute('class', 'v1-pc v1-wd');
    s.setAttribute('viewBox', A_VB);
    s.setAttribute('width', w); s.setAttribute('height', String(p.h));
    s.setAttribute('aria-hidden', 'true'); s.setAttribute('focusable', 'false');
    s.innerHTML = '<defs><linearGradient id="' + id + '" gradientUnits="userSpaceOnUse" x1="20" y1="0" x2="80" y2="100">' +
      '<stop offset="0" stop-color="#f5ebce"/><stop offset=".4" stop-color="#e6cea1"/><stop offset=".7" stop-color="#d7b986"/><stop offset="1" stop-color="#c69c68"/>' +
      '</linearGradient></defs><path fill="url(#' + id + ') #d7b986" d="' + A_YOL + '"/>';
    s.style.setProperty('--d', '0');
    return s;
  };

  // altın ışık her kelimeye ayrı ayrı ama bütün yazıya yayılan tek geçiş gibi: kelime, yazının kapladığı alanın geçişinden kendi dilimini gösterir
  const gilded = new Set();
  // Hız (25 Ekim 2026): birden çok yazı birlikte ölçülüp sonra yazılır (gildAll); tek tek ölçüp yazmak her seferinde stili yeniden hesaplatıyordu
  const gild = (box) => { const y = olcGild(box); if (y) y(); };
  const gildAll = (boxes) => boxes.map(olcGild).forEach((y) => y && y());
  const olcGild = (box) => {
    if (!box.isConnected) { gilded.delete(box); return null; }
    const ws = [...box.querySelectorAll('.v1-wd.v1-gold')];
    if (!ws.length) return null;
    // sayfaya göre konum (offsetParent zinciri sonuna kadar; kaydırma ve kelimelerin animasyon kayması etkilemez). Yalnız kelimeler arası
    // farklar kullanıldığı için yazının kutusunun konumlu olması gerekmez (hız, 9 Ekim: eskiden kutu konumlu yapılsın diye stil zorla hesaplanıyordu)
    const pos = ws.map((p) => { let x = 0, y = 0, n = p; while (n) { x += n.offsetLeft; y += n.offsetTop; n = n.offsetParent; } return [x, y, p.offsetWidth, p.offsetHeight]; });
    const L = Math.min(...pos.map((r) => r[0])), T = Math.min(...pos.map((r) => r[1]));
    const W = Math.max(...pos.map((r) => r[0] + r[2])) - L, Hh = Math.max(...pos.map((r) => r[1] + r[3])) - T;
    if (!W || !Hh) return null;
    return () => ws.forEach((p, i) => {
      p.style.backgroundSize = W + 'px ' + Hh + 'px';
      p.style.backgroundPosition = (L - pos[i][0]) + 'px ' + (T - pos[i][1]) + 'px';
    });
  };
  const ro = 'ResizeObserver' in window ? new ResizeObserver((es) => gildAll(es.map((e) => e.target))) : null;
  // hız (9 Ekim): ilk ölçüm de ResizeObserver'ın ilk çağrısında, tarayıcının kendi yerleşim hesabından sonra yapılır (zorla ölçüm yok)
  const watchGild = (box) => { gilded.add(box); if (ro) ro.observe(box); else gild(box); };
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => gildAll([...gilded]));
  // dil denetimi (9 Ekim): Arapça, Kiril … harfleri yalnız gerekince iner; inince kelimeler genişler, altın geçiş yeniden ölçülür (karede bir kez)
  let fontKare = 0;
  if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', () => { if (!fontKare) fontKare = requestAnimationFrame(() => { fontKare = 0; gildAll([...gilded]); }); });

  // ekrana girince canlan (bir kez). Aynı anda girenler sırayla (BATCH ms arayla).
  const reveal = (el, k) => {
    el.style.setProperty('--b', String(k * BATCH));
    el.classList.add('v1-in');
    const n = el.querySelectorAll('.v1-wd').length;
    const son = el._v1son != null ? el._v1son + STAGGER : n * STAGGER;   // son kelimenin gecikmesi (kısaltılmış kelime arasında daha erken)
    setTimeout(() => el.classList.add('v1-done'), k * BATCH + son + DUR + 300);
    if (el.classList.contains('v1-sig')) {
      setTimeout(() => el.querySelectorAll('svg:not(.v1-ln):not(.v1-pc) path').forEach((p) => {
        if (p.getAnimations) p.getAnimations().forEach((a) => { try { a.currentTime = 0; a.play(); } catch (e) {} });
      }), k * BATCH + n * STAGGER + 200);
    }
  };
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => {
    const vis = es.filter((e) => e.isIntersecting).map((e) => e.target)
      .sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1);
    vis.forEach((el, k) => { io.unobserve(el); reveal(el, Math.min(k, 6)); });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0 }) : null;
  const arm = (el) => { if (RM || !io) { el.classList.add('v1-in', 'v1-done'); return; } io.observe(el); };

  // TEK animasyon: yazının kelimeleri yerinde sarılır (metin değişmez, bağlantılar ve el yazısı çizimleri yerinde kalır)
  // opt.gold: true (altın çapraz ışık) · '--degisken' · ya da doğrudan bir geçiş (öteki sayfalarda yazının kendi altını korunur)
  // opt.stagger: kelime arası (ms; varsayılan 60 — öteki sayfalarda uzun paragraflar için kısaltılır)
  const SKIP = '.sr-only, svg, .v1-kick, .v1-ggt, .v1-wd';
  const words = (el, opt = {}) => {
    if (!el || el.classList.contains('v1-t')) return 0;
    const tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => (n.parentElement.closest(SKIP) || !n.data.trim()) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT,
    });
    const nodes = []; while (tw.nextNode()) nodes.push(tw.currentNode);
    const st = opt.stagger || STAGGER;
    let i = opt.start || 0;
    nodes.forEach((n) => {
      const frag = document.createDocumentFragment();
      n.data.split(/([ \t\r\n]+)/).forEach((part) => {
        if (!part) return;
        if (!part.trim()) { frag.appendChild(document.createTextNode(' ')); return; }
        const w = mk('span', 'v1-wd' + (opt.gold ? ' v1-gold' : ''), part);
        w.style.setProperty('--d', String(Math.round(i * st))); i++;
        frag.appendChild(w);
      });
      n.replaceWith(frag);
    });
    el._v1son = Math.round(Math.max(0, i - 1) * st);
    el.classList.add('v1-t');
    if (opt.gold) {
      el.style.setProperty('background', 'none', 'important');
      if (opt.gold !== true) el.style.setProperty('--v1-g', String(opt.gold).startsWith('--') ? 'var(' + opt.gold + ')' : opt.gold);
      watchGild(el);
    }
    if (!opt.noArm) arm(el);
    return i;
  };

  const heading = (h2, pc, al) => {
    if (!h2 || h2.querySelector(':scope > .v1-kick')) return;
    const kick = mk('span', 'v1-kick');
    kick.setAttribute('aria-hidden', 'true');
    kick.dataset.al = al;
    kick.append(line('l'), piece(pc), line('r'));
    const sig = !!h2.querySelector('svg');   // "Ustamız N. Sayın": imza çizimi yerinde kalır, yalnız yazı kısmı sarılır
    words(h2, { gold: true, start: 1, noArm: true });
    h2.prepend(kick);
    h2.classList.add('v1-h');
    if (sig) {
      h2.classList.add('v1-sig');
      if (!RM) h2.querySelectorAll('svg:not(.v1-ln):not(.v1-pc) path').forEach((p) => {
        if (p.getAnimations) p.getAnimations().forEach((a) => { try { a.pause(); a.currentTime = 0; } catch (e) {} });
      });
    }
    arm(h2);
  };

  /* ---- ürün adlarında ışıltı ---- */
  const glowOn = !RM && CSS.supports && CSS.supports('selector(:has(*))');
  // kutu boyu değişince ışık katmanı yeniden yerleşir
  const roG = 'ResizeObserver' in window ? new ResizeObserver((es) => {
    const l = [];
    es.forEach((e) => e.target.querySelectorAll(':scope > .v1-ggt').forEach((ov) => ov._src && l.push([ov._src, ov])));
    placeGlowAll(l);
  }) : null;
  // Katman, en yakın konumlu ataya göre yerleşir. Adın kutusu (h2/a) bilerek konumlu yapılmaz: altın yazı ışığı (background-clip:text)
  // konumlu iç öğeleri de boyar ve ekran okuyucu için gizli ad ("sr-only") görünür hâle gelirdi.
  // Hız (25 Ekim 2026, sahibi: "donma kasma olmasın"): ölçme ile yazma ayrı. Birden çok katman yerleşirken önce hepsi ölçülür, sonra
  // hepsine yazılır; eskiden her katmanda ölçüp yazmak, sonraki ölçümde bütün sayfanın yerleşimini yeniden hesaplatıyordu
  // (koleksiyon sayfasında 24 kart, telefon hızında ~1 sn). Konumlar aynı.
  const olcGlow = (svg, ov) => {
    const op = ov.offsetParent;
    if (!op || !svg.isConnected) return null;
    const pr = op.getBoundingClientRect(), sr = svg.getBoundingClientRect();
    const sc = op.offsetWidth ? pr.width / op.offsetWidth : 1;
    if (!sc || !sr.width) return null;
    return [(sr.left - pr.left) / sc - op.clientLeft, (sr.top - pr.top) / sc - op.clientTop, sr.width / sc, sr.height / sc];
  };
  const yazGlow = (ov, o) => {
    ov.style.left = o[0] + 'px';
    ov.style.top = o[1] + 'px';
    ov.style.width = o[2] + 'px';
    ov.style.height = o[3] + 'px';
  };
  const placeGlowAll = (l) => {
    const o = l.map(([svg, ov]) => olcGlow(svg, ov));
    l.forEach(([, ov], i) => { if (o[i]) yazGlow(ov, o[i]); });
  };
  const placeGlow = (svg, ov) => placeGlowAll([[svg, ov]]);
  const syncGlow = (svg, ov) => {
    const ps = svg.querySelectorAll('path');
    ps.forEach((p, i) => {
      const k = ov.children[i]; if (!k) return;
      const cp = k.firstChild;
      const st = p.getAttribute('style') || '';
      if (cp.getAttribute('style') !== st) cp.setAttribute('style', st);
      const oa = p.getAnimations ? p.getAnimations() : [];
      (cp.getAnimations ? cp.getAnimations() : []).forEach((ca) => {
        const o = oa.find((a) => a.animationName === ca.animationName);
        if (!o) return;
        try { if (o.startTime != null) ca.startTime = o.startTime; else ca.currentTime = o.currentTime; } catch (e) {}
      });
      const draw = oa.find((a) => a.animationName === 'gg-hello-draw');
      if (draw && draw.effect) {
        const t = draw.effect.getTiming();
        const want = 'v1-glow ' + (Number(t.duration) + 500) + 'ms ease-out ' + Number(t.delay) + 'ms both';
        if (k.dataset.g !== want) { k.style.animation = want; k.dataset.g = want; }
        const ga = k.getAnimations().find((a) => a.animationName === 'v1-glow');
        try { if (ga) { if (draw.startTime != null) ga.startTime = draw.startTime; else ga.currentTime = draw.currentTime; } } catch (e) {}
      } else if (k.dataset.g) { k.style.animation = ''; delete k.dataset.g; }
    });
  };
  const glow = (svg) => {
    if (!glowOn || !svg || svg.classList.contains('hidden')) return;
    let ov = svg.nextElementSibling;
    // hız (9 Ekim): katman zaten yerindeyse dokunulmaz (eskiden slayt her değiştiğinde 5 katman zorla ölçülüp yoklanıyordu, kare başına 50–270 ms).
    // Boyut değişimini ResizeObserver, çizimin başlamasını ve zamanlamasını her katmanın kendi MutationObserver'ı izler.
    if (ov && ov.classList.contains('v1-ggt') && ov._src === svg && ov.children.length === svg.querySelectorAll('path').length) return;
    if (ov && ov.classList.contains('v1-ggt')) { ov.remove(); ov = null; }
    if (!ov) {
      ov = mk('span', 'v1-ggt'); ov.setAttribute('aria-hidden', 'true'); ov._src = svg;
      svg.querySelectorAll('path').forEach((p) => {
        const s = svgEl('svg', { viewBox: svg.getAttribute('viewBox'), fill: 'none', stroke: 'currentColor', 'aria-hidden': 'true', focusable: 'false',
          'stroke-width': svg.getAttribute('stroke-width') || '44', 'stroke-linejoin': svg.getAttribute('stroke-linejoin') || 'round' });
        s.appendChild(p.cloneNode(false));
        ov.appendChild(s);
      });
      svg.parentElement.classList.add('v1-ggp');
      svg.after(ov);
      if (roG) roG.observe(svg.parentElement);
      new MutationObserver(() => syncGlow(svg, ov)).observe(svg, { attributes: true, attributeFilter: ['style'], subtree: true });
      // renk ve konum, bu döngüde eklenen bütün katmanlarla birlikte (aynı görevin sonunda, ilk boyamadan önce)
      yeniGlow.push([svg, ov]);
      if (!yeniPlan) { yeniPlan = true; queueMicrotask(yeniYerlestir); }
    } else syncGlow(svg, ov);
    sonraGlow.add(ov);
    if (!sonraPlan) sonraPlan = requestAnimationFrame(() => { sonraPlan = requestAnimationFrame(sonraYerlestir); });
  };
  const yeniGlow = [];
  let yeniPlan = false;
  const yeniYerlestir = () => {
    yeniPlan = false;
    const l = yeniGlow.splice(0).filter(([svg, ov]) => svg.isConnected && ov.isConnected);
    const renk = l.map(([svg]) => getComputedStyle(svg).color);
    l.forEach(([, ov], i) => { ov.style.color = renk[i]; });
    placeGlowAll(l);
    l.forEach(([svg, ov]) => syncGlow(svg, ov));
  };
  // iki kare sonra bir kez daha (yazı tipleri ve React'in son çizimi oturunca), bütün katmanlar birlikte
  const sonraGlow = new Set();
  let sonraPlan = 0;
  const sonraYerlestir = () => {
    sonraPlan = 0;
    const l = [...sonraGlow].filter((ov) => ov._src && ov.isConnected).map((ov) => [ov._src, ov]);
    sonraGlow.clear();
    placeGlowAll(l);
    l.forEach(([svg, ov]) => syncGlow(svg, ov));
  };
  // sel: ışıltı alacak el yazısı çizimleri (ana sayfada üst görsel + dört kart; öteki sayfaların seçicisi sayfa-animasyon.js'te)
  const glowAll = (sel) => {
    document.querySelectorAll('.v1-ggt').forEach((ov) => { if (!ov._src || !ov._src.isConnected || ov._src.nextElementSibling !== ov) ov.remove(); });
    document.querySelectorAll(sel).forEach(glow);
  };
  addEventListener('resize', () => placeGlowAll([...document.querySelectorAll('.v1-ggt')].filter((ov) => ov._src).map((ov) => [ov._src, ov])));

  // Ana sayfaya sonradan eklenen bölümler ve öteki sayfalar (sayfa-animasyon.js) aynı tek animasyonu, satranç taşı işaretini,
  // altın başlığı ve ürün adı ışıltısını buradan kullanır: ggAna.heading(h2, 'fil', 'center'), ggAna.words(el, { gold: true }),
  // ggAna.arm(el), ggAna.piece('at'), ggAna.line('l'), ggAna.glow(svg), ggAna.glowAll(seçici), ggAna.RM (hareket azaltma açık mı)
  // ggAna.altinYenile(): yazısı sonradan değişen altın kelimelerin (ör. ab-para-birimi.js'in çevirdiği fiyat) ışığı yeniden ölçülür
  window.ggAna = { words, heading, arm, piece, line, glow, glowAll, RM, DUR, STAGGER, BATCH, EASE, altinYenile: () => gildAll([...gilded]) };
  if (!ANA) return;   // buradan sonrası yalnız ana sayfa

  /* ---- bölümler ---- */
  const SECS = [
    { key: 'slider', run(isl) {
      isl.querySelectorAll('div.relative.mx-auto.flex.h-full').forEach((blk) => {
        const lab = blk.querySelector(':scope > span');
        const ps = [...blk.querySelectorAll(':scope > p, :scope > div > p')].filter((p) => p.textContent.trim() && !p.closest('button'));
        const price = ps.find((p) => p.matches('.mt-1.text-lg') || /\p{Sc}|\d[.,\u00a0\u202f'’]\d{3}/u.test(p.textContent) || !!(window.GG && window.GG.currency && p.textContent.includes(window.GG.currency)));
        if (lab) words(lab, { gold: true });
        ps.forEach((p) => words(p, p === price ? { gold: '--gg-altin-isik' } : {}));
      });
    } },
    { key: 'tiles', run(isl) {
      heading(isl.querySelector('h2'), 'piyon', 'center');
      const a = isl.querySelector('div:has(> div.max-w-2xl > h2) > a');
      const sp = a && a.querySelector('span.underline');
      if (sp && !sp.classList.contains('v1-t')) { a.classList.add('v1-gl'); a.style.setProperty('background', 'none', 'important'); words(sp, { gold: true }); }
      isl.querySelectorAll('[data-slot="product-card-subtitle"]').forEach((p) => words(p));
      isl.querySelectorAll('[data-slot="product-card-metric"]').forEach((p) => words(p, { gold: '--gg-altin-isik' }));
    } },
    { key: 'artisan_arc', run(isl) {
      heading(isl.querySelector('h2'), 'at', 'start');
      words(isl.querySelector('div.lg\\:col-span-5 + div > p'));
    } },
    { key: 'promo', run(isl) {
      heading(isl.querySelector('h2'), 'fil', 'center');
      isl.querySelectorAll('h3').forEach((h3) => {
        const box = h3.parentElement;
        if (!h3.classList.contains('v1-t')) { h3.classList.add('v1-hs'); words(h3, { gold: true }); }
        box.querySelectorAll(':scope > p').forEach((p) => { if (!p.classList.contains('mt-3')) words(p); });
        // alttaki bağlantı ("Bir takımın yolculuğu" …): altın gezinme etiketi, ok yok (etiket sabiti)
        const row = box.querySelector(':scope > div.mt-3, :scope > p.mt-3');
        const cta = row && (row.querySelector(':scope > span') || row);
        if (cta && !cta.classList.contains('v1-t')) { row.classList.add('v1-cta'); words(cta, { gold: true }); }
      });
    } },
    { key: 'globe', run(isl) {
      const h2 = isl.querySelector('h2');
      if (h2) words(h2, { gold: true });   // yalnız yazı; küre aynı kalır
    } },
    { key: 'faq', run(isl) {
      heading(isl.querySelector('h2'), 'kale', 'start');
      const a = isl.querySelector('a[href$="/pages/sss"]');
      if (a && !a.classList.contains('v1-t')) words(a, { gold: true });
      isl.querySelectorAll('div.border-t > div > h3 > button').forEach((b) => {
        if (b.querySelector(':scope > .v1-qt')) return;
        const t = [...b.childNodes].find((n) => n.nodeType === 3 && n.data.trim());
        if (!t) return;
        const s = mk('span', 'v1-qt');
        t.replaceWith(s); s.appendChild(t);
        words(s);
      });
    } },
    { key: 'newsletter', run(isl) {
      heading(isl.querySelector('h2'), 'vezir', 'lgstart');
      words(isl.querySelector('h2 + p'));
      isl.querySelectorAll('form p').forEach((p) => words(p));
    } },
  ];

  const proc = (cfg) => {
    const isl = cfg.isl;
    if (!isl.hasAttribute('data-mounted')) return;
    try { cfg.run(isl); } catch (e) { /* bölümün kendi görünüşü kalır */ }
    if (cfg.key === 'slider' || cfg.key === 'tiles') glowAll('main [id$="__tiles"] h3[data-slot="product-card-title"] a > svg, main [id$="__slider"] h2 > svg');
    if (isl.querySelector('.v1-t')) cfg.sec.classList.remove('v1-pend');
  };

  const start = () => {
    SECS.forEach((cfg) => {
      const sec = document.querySelector('main > .shopify-section[id$="__' + cfg.key + '"]');
      const isl = sec && sec.querySelector(':scope > .gg-island');
      if (!isl) return;
      cfg.sec = sec; cfg.isl = isl;
      if (!RM) sec.classList.add('v1-pend');
      // adacık React ile çizildikten sonra, ilk boyamadan önceki karede (requestAnimationFrame) işlenir; React yeniden çizerse ya da
      // slayt değişirse yeniden uygulanır. Hız (9 Ekim, sahibi: "Ustamız kısmı açılırken kasıyor"): eskiden React'in kendi çizim işinin
      // içinde, her değişiklikte hemen çalışıyordu; şimdi aynı karedeki değişiklikler birleştirilip karede bir kez işlenir. Yazılar
      // işlenene kadar zaten gizli (v1-pend), görünüş aynı.
      const planla = () => { if (!cfg.plan) cfg.plan = requestAnimationFrame(() => { cfg.plan = 0; proc(cfg); }); };
      new MutationObserver(planla).observe(isl, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-mounted'] });
      proc(cfg);
      setTimeout(() => sec.classList.remove('v1-pend'), 6000);   // güvenlik: adacık hiç açılmazsa yazılar gizli kalmasın
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

} catch (e) { console.error("gg-yayin: ana-v1.js", e); }

/* ==== defne-rozeti.js ==== */
try {
/* Preview: laurel tag on the top-left of every product photo (product gallery slides and product cards) */
(() => {
  const TARGETS = [
    ['.gg-main-product div.shrink-0.w-full.aspect-square', ''],   // product page gallery slides
    ['div.group\\/card-image', 'sm'],                              // product cards (collections, related, home)
  ];
  // Hız (25 Ekim 2026, sahibi: "donma kasma olmasın"): rozeti olmayan kutular önce toplanır ve hepsi birlikte okunur (position), sonra
  // rozetler eklenir; eskiden her kutuda okuyup hemen eklemek bir sonraki okumada bütün sayfanın stilini yeniden hesaplatıyordu (koleksiyon
  // sayfasında, telefon hızında ~0,6 sn). Sayfadaki değişikliklere de her değişiklikte değil, karede bir kez bakılır (ilk boyamadan önce).
  const add = () => {
    const yeni = [];
    for (const [sel, size] of TARGETS) {
      document.querySelectorAll(sel).forEach((box) => {
        if (!box.querySelector(':scope > .gg-laurel-tag')) yeni.push([box, size]);
      });
    }
    if (!yeni.length) return;
    const statik = yeni.map(([box]) => getComputedStyle(box).position === 'static');
    yeni.forEach(([box, size], i) => {
      if (statik[i]) box.style.position = 'relative';
      box.insertAdjacentHTML('beforeend', `<span class="gg-laurel-tag ${size}" aria-hidden="true"><span class="gg-award__laurel"></span></span>`);
      bak(box);
    });
  };

  // 28 Ekim 2026 (sahibi: "logonun arkasında siyah bir gölge var, bu beyaz arka plana sahip görsellerde kötü duruyor, bunlarda olmasın"):
  // fotoğrafın sol üst köşesi (rozetin durduğu yer) açıksa rozete gg-laurel-tag--acik eklenir, gölge kalkar (aurum.css A37). Köşe,
  // fotoğrafın 16x16'lık küçük bir kopyasından ölçülür: önce sayfadaki görselin kendisi (aynı alan adındaysa), olmazsa Shopify'dan
  // 64 px'lik kopyası (CORS açık). Sonuç adrese göre saklanır (sessionStorage), aynı görsel bir daha ölçülmez. Ölçüm boşta çalışır.
  const ANAHTAR = 'gg_defne_acik';
  let kayit = {};
  try { kayit = JSON.parse(sessionStorage.getItem(ANAHTAR) || '{}') || {}; } catch (e) { kayit = {}; }
  const sakla = () => { try { sessionStorage.setItem(ANAHTAR, JSON.stringify(kayit)); } catch (e) { /* özel pencere */ } };
  const tuval = document.createElement('canvas');
  tuval.width = tuval.height = 16;
  const ctx = tuval.getContext('2d', { willReadFrequently: true });
  const anahtar = (src) => (src || '').replace(/^https?:/, '').replace(/[?&]width=\d+/, '').split('&')[0];
  const kucuk = (src) => {
    const u = new URL(src, location.href);
    u.searchParams.set('width', '64');
    return u.href;
  };
  // köşe açık mı: sol üst %28'lik karenin ortalama parlaklığı (0-255) 205'ten yüksek ve neredeyse renksizse beyaz/açık zemin
  const olc = (img) => {
    const w = img.naturalWidth, h = img.naturalHeight;
    if (!w || !h) return null;
    const k = Math.min(w, h) * 0.28;
    ctx.clearRect(0, 0, 16, 16);
    ctx.drawImage(img, 0, 0, k, k, 0, 0, 16, 16);
    const d = ctx.getImageData(0, 0, 16, 16).data;
    let top = 0;
    for (let i = 0; i < d.length; i += 4) top += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
    return top / (d.length / 4) > 205;
  };
  const uygula = (box, acik) => {
    const tag = box.querySelector(':scope > .gg-laurel-tag');
    if (tag) tag.classList.toggle('gg-laurel-tag--acik', !!acik);
  };
  const sira = [];
  let calisiyor = false;
  const bosta = (fn) => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 1500 }) : setTimeout(fn, 200));
  const gorsel = (box) => {
    const hepsi = box.querySelectorAll('img');
    for (const im of hepsi) if (im.getClientRects().length) return im; // görünen (açık/koyu ikizlerden ekrandaki)
    return hepsi[0] || null;
  };
  function bak(box) { sira.push(box); if (!calisiyor) { calisiyor = true; bosta(isle); } }
  function isle(deadline) {
    while (sira.length && (!deadline || deadline.timeRemaining() > 4 || deadline.didTimeout)) {
      const box = sira.shift();
      const img = gorsel(box);
      const src = img && (img.currentSrc || img.src);
      if (!src) continue;
      const a = anahtar(src);
      if (a in kayit) { uygula(box, kayit[a]); continue; }
      const bitti = (acik) => { if (acik === null) return; kayit[a] = acik; sakla(); uygula(box, acik); };
      const yedek = () => {
        const k = new Image();
        k.crossOrigin = 'anonymous';
        k.decoding = 'async';
        k.onload = () => { try { bitti(olc(k)); } catch (e) { /* ölçülemedi: gölge kalır */ } };
        k.src = kucuk(src);
      };
      const dene = () => {
        try { bitti(olc(img)); } catch (e) { yedek(); } // başka alan adından gelen görsel tuvali kirletir: küçük CORS kopyası
      };
      if (img.complete && img.naturalWidth) dene();
      else img.addEventListener('load', dene, { once: true });
    }
    if (sira.length) bosta(isle); else calisiyor = false;
  }

  add();
  let plan = 0;
  new MutationObserver(() => { if (!plan) plan = requestAnimationFrame(() => { plan = 0; add(); }); }).observe(document.body, { childList: true, subtree: true });
})();

} catch (e) { console.error("gg-yayin: defne-rozeti.js", e); }

/* ==== galeri-ok.js ==== */
try {
/* 47) Görsel galerisindeki ileri/geri okları (cam yuvarlak düğmeler): dokununca ya da üzerine gelince görünür.
   Sitede son hareketten 2,5 sn sonra 0,5 sn'de kayboluyordu; sahibinin isteğiyle: 1 sn görünür, sonra 0,6 sn'de yumuşakça kaybolur.
   Yayında: galeri bileşenindeki gizlenme süresi (2500 → 1000 ms) ve kayboluş geçişi (500 ms → 600 ms, yumuşak ease-in-out) değişecek; bu betik yayına gitmez. */
(() => {
  const SURE = 1000;
  // okların adı sayfanın dilinde (sitenin kendi çevirisi; aa-dil.js · ceviri/ceviriler.json secici.*) — 9 Ekim: eskiden yalnız Türkçe sayfada çalışıyordu
  const T = (k, yedek) => (window.ggDil ? window.ggDil.t(k, null, yedek) : yedek);
  const ADLAR = [...new Set(['Önceki görsel', 'Sonraki görsel', T('secici.galeri_onceki', 'Önceki görsel'), T('secici.galeri_sonraki', 'Sonraki görsel')])];
  const OKLAR = ADLAR.map((a) => 'button[aria-label="' + a.replace(/"/g, '\\"') + '"]').join(', ');
  const css = document.createElement('style');
  css.textContent = OKLAR.split(',').map((s) => s.trim() + '.gg-ok-gizle').join(',') + '{opacity:0!important;transition:opacity .6s cubic-bezier(.45,0,.25,1),scale .6s cubic-bezier(.45,0,.25,1)!important}';
  document.head.appendChild(css);

  const sayac = new WeakMap();
  const kur = (kap) => {
    if (!kap || kap.dataset.ggOk) return;
    kap.dataset.ggOk = '1';
    const oklar = () => kap.querySelectorAll(OKLAR);
    const tetik = () => {
      oklar().forEach((b) => b.classList.remove('gg-ok-gizle'));
      clearTimeout(sayac.get(kap));
      sayac.set(kap, setTimeout(() => oklar().forEach((b) => b.classList.add('gg-ok-gizle')), SURE));
    };
    ['pointerdown', 'pointermove', 'pointerenter', 'touchstart', 'focusin'].forEach((e) => kap.addEventListener(e, tetik, { passive: true }));
    // site okları kendi başına gösterirse (sınıf opacity-100 olur) sayaç yine başlar
    new MutationObserver((ms) => {
      if (ms.some((m) => m.target.classList.contains('opacity-100') && !(m.oldValue || '').includes('opacity-100'))) tetik();
    }).observe(kap, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });
  };
  const tara = () => document.querySelectorAll(OKLAR).forEach((b) => kur(b.parentElement));
  tara();
  new MutationObserver(tara).observe(document.body, { childList: true, subtree: true });
})();

} catch (e) { console.error("gg-yayin: galeri-ok.js", e); }

/* ==== gg-footer.js ==== */
try {
/* Footer (Aurum Galerie, 21 Ekim 2026): altın kalemle çizilen AURUM, cam yazının yerine geçer ve ekrana girince bir kez oynar (GG'deki GG çizimiyle aynı davranış) */
(() => {
  // Aurum Galerie (21 Ekim 2026): "GG" yerine "AURUM" (Cormorant Garamond 600, harf aralığı 0,16 em; marka/aurum-yazi.json).
  // Her harf ayrı yol: kalem harf harf çizer (gecikme --i), sonra altın camla dolar, bir kez ışık geçer.
  const HARF = ["M355.76171875 -18.0478515625 672.0009765625 694.0H524.25927734375L308.64111328125 142.12255859375ZM140.76171875 627.0Q132.9521484375 647.0 137.9521484375 661.0Q142.9521484375 675.0 154.85693359375 682.5Q166.76171875 690.0 178.76171875 690.0H187.76171875V700.0H-22.1435546875V690.0Q-22.1435546875 690.0 -17.6435546875 690.0Q-13.1435546875 690.0 -13.1435546875 690.0Q9.8564453125 690.0 34.3564453125 675.5Q58.8564453125 661.0 74.8564453125 627.0ZM355.76171875 -18.0478515625 361.11865234375 86.763671875 112.142578125 697.0H43.64208984375L301.666015625 103.572265625Q303.68994140625 99.92919921875 310.404296875 84.595703125Q317.11865234375 69.26220703125 325.42822265625 49.23828125Q333.73779296875 29.21435546875 340.04736328125 10.59521484375Q346.35693359375 -8.02392578125 346.76171875 -18.0478515625ZM472.87939453125 450.07275390625V488.16845703125H172.02294921875V450.07275390625ZM497.64013671875 627.0H641.97705078125Q657.78662109375 661.0 682.3818359375 675.5Q706.97705078125 690.0 729.97705078125 690.0Q729.97705078125 690.0 733.97705078125 690.0Q737.97705078125 690.0 737.97705078125 690.0V700.0H450.64013671875V690.0H459.64013671875Q479.044921875 690.0 494.247314453125 673.5Q509.44970703125 657.0 497.64013671875 627.0Z", "M1067.57421875 0.0V440.0Q1067.57421875 511.1904296875 1092.252685546875 564.16650390625Q1116.93115234375 617.142578125 1161.895263671875 646.0234375Q1206.859375 674.904296875 1267.4306640625 674.904296875Q1330.78759765625 674.904296875 1376.942138671875 647.5234375Q1423.0966796875 620.142578125 1448.66796875 570.464111328125Q1474.2392578125 520.78564453125 1474.2392578125 453.0V0.0H1537.4306640625V448.9521484375Q1537.4306640625 529.380859375 1503.323486328125 588.892822265625Q1469.21630859375 648.40478515625 1405.78759765625 681.202392578125Q1342.35888671875 714.0 1255.287109375 714.0Q1156.50048828125 714.0 1087.119140625 681.5Q1017.73779296875 649.0 981.821044921875 589.6904296875Q945.904296875 530.380859375 945.904296875 449.9521484375V0.0ZM948.904296875 0.0V60.0H945.904296875Q945.904296875 38.0 930.404296875 24.0Q914.904296875 10.0 892.904296875 10.0Q892.904296875 10.0 884.904296875 10.0Q876.904296875 10.0 876.904296875 10.0V0.0ZM1136.57421875 0.0V10.0Q1136.57421875 10.0 1128.57421875 10.0Q1120.57421875 10.0 1120.57421875 10.0Q1098.57421875 10.0 1083.07421875 24.0Q1067.57421875 38.0 1067.57421875 60.0H1065.57421875V0.0ZM1477.2392578125 0.0V60.0H1474.2392578125Q1474.2392578125 38.0 1458.7392578125 24.0Q1443.2392578125 10.0 1421.2392578125 10.0Q1421.2392578125 10.0 1413.2392578125 10.0Q1405.2392578125 10.0 1405.2392578125 10.0V0.0ZM1606.4306640625 0.0V10.0Q1606.4306640625 10.0 1598.4306640625 10.0Q1590.4306640625 10.0 1590.4306640625 10.0Q1568.4306640625 10.0 1552.9306640625 24.0Q1537.4306640625 38.0 1537.4306640625 60.0H1535.4306640625V0.0Z", "M1999.955078125 0.0H2132.859375Q2177.859375 0.0 2218.609619140625 10.97607421875Q2259.35986328125 21.9521484375 2290.02685546875 44.8330078125Q2320.69384765625 67.7138671875 2338.444091796875 103.225830078125Q2356.1943359375 138.73779296875 2356.1943359375 188.40478515625Q2356.1943359375 232.35693359375 2337.135009765625 274.940185546875Q2318.07568359375 317.5234375 2281.19482421875 346.23779296875Q2244.31396484375 374.9521484375 2190.2421875 379.0Q2217.36181640625 388.02392578125 2241.814453125 412.559814453125Q2266.26708984375 437.095703125 2282.4814453125 461.1435546875Q2283.291015625 462.35791015625 2294.564697265625 479.631591796875Q2305.83837890625 496.9052734375 2323.10009765625 521.869384765625Q2340.36181640625 546.83349609375 2358.5283203125 571.8095703125Q2376.69482421875 596.78564453125 2391.2900390625 614.0Q2412.50439453125 639.64306640625 2431.2900390625 656.23828125Q2450.07568359375 672.83349609375 2471.14697265625 681.21435546875Q2492.21826171875 689.59521484375 2519.1943359375 690.0V700.0H2435.859375Q2384.1923828125 700.0 2343.608642578125 688.83349609375Q2303.02490234375 677.6669921875 2272.941162109375 655.750244140625Q2242.857421875 633.83349609375 2220.78564453125 601.4755859375Q2214.54736328125 591.80859375 2203.678466796875 573.21337890625Q2192.8095703125 554.6181640625 2179.774169921875 531.963623046875Q2166.73876953125 509.30908203125 2154.608154296875 487.559326171875Q2142.4775390625 465.8095703125 2133.525390625 448.9287109375Q2124.5732421875 432.0478515625 2121.763671875 425.0Q2106.40673828125 395.54736328125 2087.0498046875 377.78564453125Q2067.69287109375 360.02392578125 2045.955078125 358.0V348.0Q2047.57421875 348.0 2058.823974609375 348.297607421875Q2070.07373046875 348.59521484375 2083.97802734375 348.0Q2110.78759765625 347.40478515625 2138.14453125 337.97607421875Q2165.50146484375 328.54736328125 2187.64404296875 304.5234375Q2209.78662109375 280.49951171875 2220.1435546875 236.30908203125Q2222.333984375 226.5234375 2223.92919921875 212.85693359375Q2225.5244140625 199.1904296875 2224.5244140625 184.0Q2222.31005859375 113.5712890625 2189.21484375 77.726318359375Q2156.11962890625 41.88134765625 2104.572265625 40.095703125Q2085.88232421875 38.9052734375 2065.085205078125 39.202880859375Q2044.2880859375 39.50048828125 2028.74072265625 39.50048828125Q2013.193359375 39.50048828125 2009.955078125 39.50048828125Q2009.955078125 38.9052734375 2007.455078125 29.178955078125Q2004.955078125 19.45263671875 2002.455078125 9.726318359375Q1999.955078125 0.0 1999.955078125 0.0ZM2012.955078125 0.0V700.0H1890.88037109375V0.0ZM1893.88037109375 627.0V700.0H1813.88037109375V690.0Q1814.68994140625 690.0 1820.582763671875 690.0Q1826.4755859375 690.0 1826.88037109375 690.0Q1852.88037109375 690.0 1871.38037109375 671.5Q1889.88037109375 653.0 1890.88037109375 627.0ZM1893.88037109375 73.0H1890.88037109375Q1889.88037109375 47.0 1871.38037109375 28.5Q1852.88037109375 10.0 1826.88037109375 10.0Q1826.4755859375 10.0 1820.582763671875 10.0Q1814.68994140625 10.0 1813.88037109375 10.0V0.0H1893.88037109375ZM2009.955078125 627.0H2012.955078125Q2012.955078125 653.0 2031.955078125 671.5Q2050.955078125 690.0 2076.955078125 690.0Q2077.7646484375 690.0 2083.157470703125 690.0Q2088.55029296875 690.0 2088.955078125 690.0V700.0H2009.955078125Z", "M2840.57421875 0.0V440.0Q2840.57421875 511.1904296875 2865.252685546875 564.16650390625Q2889.93115234375 617.142578125 2934.895263671875 646.0234375Q2979.859375 674.904296875 3040.4306640625 674.904296875Q3103.78759765625 674.904296875 3149.942138671875 647.5234375Q3196.0966796875 620.142578125 3221.66796875 570.464111328125Q3247.2392578125 520.78564453125 3247.2392578125 453.0V0.0H3310.4306640625V448.9521484375Q3310.4306640625 529.380859375 3276.323486328125 588.892822265625Q3242.21630859375 648.40478515625 3178.78759765625 681.202392578125Q3115.35888671875 714.0 3028.287109375 714.0Q2929.50048828125 714.0 2860.119140625 681.5Q2790.73779296875 649.0 2754.821044921875 589.6904296875Q2718.904296875 530.380859375 2718.904296875 449.9521484375V0.0ZM2721.904296875 0.0V60.0H2718.904296875Q2718.904296875 38.0 2703.404296875 24.0Q2687.904296875 10.0 2665.904296875 10.0Q2665.904296875 10.0 2657.904296875 10.0Q2649.904296875 10.0 2649.904296875 10.0V0.0ZM2909.57421875 0.0V10.0Q2909.57421875 10.0 2901.57421875 10.0Q2893.57421875 10.0 2893.57421875 10.0Q2871.57421875 10.0 2856.07421875 24.0Q2840.57421875 38.0 2840.57421875 60.0H2838.57421875V0.0ZM3250.2392578125 0.0V60.0H3247.2392578125Q3247.2392578125 38.0 3231.7392578125 24.0Q3216.2392578125 10.0 3194.2392578125 10.0Q3194.2392578125 10.0 3186.2392578125 10.0Q3178.2392578125 10.0 3178.2392578125 10.0V0.0ZM3379.4306640625 0.0V10.0Q3379.4306640625 10.0 3371.4306640625 10.0Q3363.4306640625 10.0 3363.4306640625 10.0Q3341.4306640625 10.0 3325.9306640625 24.0Q3310.4306640625 38.0 3310.4306640625 60.0H3308.4306640625V0.0Z", "M4303.90625 -14.0 4311.90625 80.93017578125 4030.142578125 610.380859375Q4030.142578125 610.380859375 4021.225830078125 627.78564453125Q4012.30908203125 645.1904296875 4003.297119140625 669.90478515625Q3994.28515625 694.619140625 3992.904296875 718.0478515625H3983.30908203125L3952.30810546875 638.8564453125ZM3646.80859375 627.0V700.0H3535.80859375V690.0Q3536.80859375 690.0 3544.30859375 690.0Q3551.80859375 690.0 3551.80859375 690.0Q3578.80859375 690.0 3599.80859375 673.5Q3620.80859375 657.0 3624.80859375 627.0ZM3685.92822265625 643.0Q3685.92822265625 644.0 3685.92822265625 645.0Q3685.92822265625 646.0 3685.92822265625 648.0Q3685.92822265625 664.0 3697.42822265625 677.5Q3708.92822265625 691.0 3724.92822265625 691.0H3740.3330078125V700.0H3678.92822265625V643.0ZM3705.07080078125 -14.0H3714.666015625L3744.78564453125 72.525390625L3680.11865234375 700.0H3615.9990234375ZM3714.666015625 -14.0 4028.572265625 551.5205078125 3983.30908203125 718.0478515625 3691.21337890625 181.3857421875ZM4312.90625 -14.0 4404.97802734375 700.0H4271.92724609375L4219.7607421875 191.55322265625L4303.90625 -14.0ZM4374.16845703125 627.0H4395.5732421875Q4400.5732421875 657.0 4421.370849609375 673.5Q4442.16845703125 690.0 4468.5732421875 690.0Q4468.5732421875 690.0 4476.370849609375 690.0Q4484.16845703125 690.0 4484.5732421875 690.0V700.0H4374.16845703125ZM4266.11767578125 643.0H4273.11767578125V700.0H4211.712890625V691.0H4227.11767578125Q4243.712890625 691.0 4254.915283203125 677.5Q4266.11767578125 664.0 4266.11767578125 648.0Q4266.11767578125 646.0 4266.11767578125 645.0Q4266.11767578125 644.0 4266.11767578125 643.0Z"];
  const VB = '-12 -16 4507 742';
  const SVG = `<svg class="gg-gold-mark gg-aurum-mark" viewBox="${VB}" aria-hidden="true"><defs>
    <linearGradient id="ggFootPen" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#f6e7c3"/><stop offset=".45" stop-color="#d7b986"/><stop offset="1" stop-color="#b68852"/></linearGradient>
    <linearGradient id="ggFootGlass" x1="0" y1="0" x2=".35" y2="1"><stop offset="0" stop-color="#f6e7c3" stop-opacity=".42"/><stop offset=".5" stop-color="#d7b986" stop-opacity=".1"/><stop offset="1" stop-color="#b68852" stop-opacity=".3"/></linearGradient>
    <linearGradient id="ggFootBand" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#fff8e6" stop-opacity="0"/><stop offset=".5" stop-color="#fff8e6" stop-opacity=".9"/><stop offset="1" stop-color="#fff8e6" stop-opacity="0"/></linearGradient>
    <clipPath id="ggFootClip"><path d="${HARF.join('')}"/></clipPath></defs>
    ${HARF.map((d, i) => `<path class="g" pathLength="1" style="--i:${i}" d="${d}"/>`).join('')}
    <g clip-path="url(#ggFootClip)"><rect class="sweep" x="-12" y="-40" width="1400" height="760" fill="url(#ggFootBand)" style="mix-blend-mode:screen"/></g></svg>`;
  let io;
  const mount = () => {
    const box = document.querySelector('footer > div.aspect-\\[360\\/100\\]');
    if (!box || box.querySelector('.gg-gold-mark')) return;
    box.insertAdjacentHTML('beforeend', SVG);
    const m = box.querySelector('.gg-gold-mark');
    io && io.disconnect();
    io = new IntersectionObserver((e) => { if (e[0].isIntersecting) { m.classList.add('play'); io.disconnect(); } }, { threshold: .5 });
    io.observe(m);
    // the floating add-to-cart island steps aside while the footer GG is on screen
    new IntersectionObserver((e) => document.documentElement.classList.toggle('gg-foot-gg-in', e[0].isIntersecting), { threshold: .15 }).observe(m);
  };
  mount();
  new MutationObserver(mount).observe(document.body, { childList: true, subtree: true });
})();

} catch (e) { console.error("gg-yayin: gg-footer.js", e); }

/* ==== header-altin.js ==== */
try {
/* 30) Header logosu için altın çapraz ışık tanımı (SABİT AYAR --gg-altin-capraz'ın SVG karşılığı: oklch .94/.86/.80/.72 → hex).
   Logo tek parça bir SVG çizimi olduğu için CSS geçişi doğrudan uygulanamıyor; dolgusu bu tanımdan gelir (palet.css madde 30). */
(() => {
  if (document.getElementById('ggAltinCapraz')) return;
  document.body.insertAdjacentHTML('beforeend',
    '<svg width="0" height="0" style="position:absolute" aria-hidden="true" focusable="false"><defs>' +
    '<linearGradient id="ggAltinCapraz" x1=".467" y1="0" x2=".533" y2="1">' +            /* 160°: geniş logoda yukarıdan aşağıya, hafif sağa */
    '<stop offset="0" stop-color="#f5ebce"/><stop offset=".4" stop-color="#e6cea1"/><stop offset=".7" stop-color="#d7b986"/><stop offset="1" stop-color="#c69c68"/>' +
    '</linearGradient></defs></svg>');
})();

} catch (e) { console.error("gg-yayin: header-altin.js", e); }

/* ==== hiz.js ==== */
try {
/* 56) Hız (9 Ekim, sahibi: "ürün sayfasındaki Ayrıntılar kısmı kasıyor", "ana sayfadaki Ustamız kısmı açılırken kasıyor").
   Ölçüm (telefon hızı, işlemci 4 kat yavaş): sayfadaki defne rozetlerinin sürekli dönen ışığı (gg-award-sweep, 7 sn, sonsuz) ve rozet
   parıltısı (ggTagGlow) ekran dışındayken bile her karede sayfanın tamamını yeniden boyatıyordu (ürün sayfasında 9 rozet; boşta beklerken
   bile saniyede yüzlerce boyama). Akordeon açılırken ya da bir bölüm belirirken bu yük üst üste binip takılma yapıyordu.
   Çözüm, görünüm aynı kalarak:
   - rozetler kendi katmanında boyanır (will-change): ışık geçerken yalnız küçük rozet yeniden boyanır, sayfanın tamamı değil;
   - ekrana yakın değilken (150 px payla) bu süs animasyonları durur, ekrana girince kaldığı yerden sürer (görünmeyen şey için iş yapılmaz).
   Hareket azaltma açıksa bu animasyonlar zaten kapalı (onizleme.css 13). */
(() => {
  const SEC = '.gg-award__laurel, .gg-laurel-tag';
  const css = document.createElement('style');
  css.textContent = `
.gg-award__laurel, .gg-laurel-tag { will-change: transform; }
.gg-dur, .gg-dur .gg-award__laurel { animation-play-state: paused !important; }`;
  document.head.appendChild(css);
  if (!('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((es) => es.forEach((e) => e.target.classList.toggle('gg-dur', !e.isIntersecting)), { rootMargin: '150px 0px' });
  const izlenen = new WeakSet();
  let plan = 0;
  const tara = () => {
    plan = 0;
    document.querySelectorAll(SEC).forEach((el) => {
      if (izlenen.has(el)) return;
      izlenen.add(el);
      el.classList.add('gg-dur');   // ilk ölçüme kadar durgun; ekrandaysa gözlemci hemen çalıştırır
      io.observe(el);
    });
  };
  const iste = () => { if (!plan) plan = requestAnimationFrame(tara); };
  tara();
  // yeni rozetler (adalar sonradan çizilince): yalnız öğe eklenince bakılır
  new MutationObserver((ms) => { if (ms.some((m) => m.addedNodes.length)) iste(); }).observe(document.body, { childList: true, subtree: true });
})();

/* 56b) Açılıştaki ağırlık (9 Ekim). Ölçüm: her sayfa açıldıktan sonra 10–20 sn boyunca (telefon hızında) ekran saniyede birkaç kez çizilebiliyordu;
   "Ayrıntılar" açılırken ve ana sayfada "Ustamız" belirirken takılmanın asıl sebebi buydu. Sebep Shopify'ın kendi kodu (checkouts/internal/preloads.js):
   ödeme sayfasının ~150 dosyasını önceden indirmek için sayfanın başına tek tek <link rel="prefetch"> ekliyor; her eklemede tarayıcı bütün sayfanın
   stilini baştan hesaplıyor ve sayfayı yeniden boyuyordu (katmansız temada da aynı). Çözüm: aynı dosyalar yine sırayla, düşük öncelikle önceden
   indirilir, ama sayfaya bağlantı eklenmeden (fetch ile; tarayıcı önbelleği aynı şekilde dolar, ödeme sayfası yine hızlı açılır). Ölçüm, aynı koşulda:
   açılıştan sonraki her 2 sn'de uzun kare süresi 750–1600 ms → 0–200 ms. Yalnız "prefetch" bağlantıları değişir; başka hiçbir eklemeye dokunulmaz. */
(() => {
  const head = document.head;
  if (!head || head._ggOnceden || !window.fetch) return;
  head._ggOnceden = true;
  const ekle = head.appendChild;
  head.appendChild = function (n) {
    if (n && n.tagName === 'LINK' && n.rel === 'prefetch' && n.href) {
      const bitti = n.onload;   // preloads.js bir dosya bitince sıradakine geçer
      fetch(n.href, { mode: 'cors', credentials: 'same-origin', priority: 'low' }).catch(() => {}).finally(() => {
        try { if (bitti) bitti.call(n, new Event('load')); } catch (e) { /* yok say */ }
      });
      return n;
    }
    return ekle.call(this, n);
  };
})();

} catch (e) { console.error("gg-yayin: hiz.js", e); }

/* ==== imza-bosluk.js ==== */
try {
/* 42) El yazısı çizimlerde kelime arası: sitenin el yazısı çizimi boşluk karakterini çok geniş bırakıyor ("N.      Sayın", harf yüksekliğinin ~3/4'ü).
   Kelimeler arasındaki boşluk 220 birime (harf yüksekliğinin ~1/3'ü) indirilir, çizimin genişliği de o kadar daralır; harfler ve çizim animasyonu aynı kalır.
   Tek kelimelik ürün adlarında böyle bir boşluk olmadığı için onlara dokunulmaz. Yayında: el yazısı bileşenindeki boşluk genişliği düzeltilecek.
   Hız düzeltmesi (9 Ekim, sahibi: "Ustamız kısmı açılırken kasıyor"): eski sürüm sayfadaki her değişiklikte bütün el yazılarını yeniden ölçüyordu
   (henüz görünmeyenler her seferinde tekrar ölçülüyordu). Şimdi her çizim yalnız ekrana yaklaşınca ve bir kez ölçülür; görünüm aynı. */
(() => {
  const HEDEF = 220, ESIK = 380;   // çizim birimi (harf yüksekliği ~666)
  const SEC = 'svg[stroke-width="44"][viewBox^="69 -688"]';
  const duzelt = (svg) => {
    if (svg.dataset.ggBosluk) return true;
    const ps = [...svg.querySelectorAll(':scope > path')];
    if (ps.length < 2) { svg.dataset.ggBosluk = '0'; return true; }
    let bb;
    try { bb = ps.map((p) => p.getBBox()); } catch (e) { return false; }
    if (bb.every((b) => b.width === 0)) return false;   // henüz çizilmemiş (gizli); görünür olunca tekrar denenir
    const sira = ps.map((_, i) => i).sort((a, b) => bb[a].x - bb[b].x);
    const kay = new Array(ps.length).fill(0);
    let kayma = 0, sag = -Infinity;
    for (const i of sira) {
      if (sag > -Infinity && bb[i].x - sag > ESIK) kayma += bb[i].x - sag - HEDEF;
      kay[i] = kayma;
      sag = Math.max(sag, bb[i].x + bb[i].width);
    }
    svg.dataset.ggBosluk = String(Math.round(kayma));
    if (!kayma) return true;
    ps.forEach((p, i) => { if (kay[i]) p.setAttribute('transform', `translate(${-kay[i]} 0)`); });
    const vb = svg.getAttribute('viewBox').trim().split(/\s+/).map(Number);
    const w0 = vb[2];
    vb[2] = w0 - kayma;
    svg.setAttribute('viewBox', vb.join(' '));
    const m = /^([\d.]+)(em|px|rem)$/.exec(svg.style.width || '');
    if (m) svg.style.width = (parseFloat(m[1]) * vb[2] / w0).toFixed(5) + m[2];
    return true;
  };
  // ölçüm yalnız çizim ekrana yaklaşınca; ölçülemezse (gizli) bir sonraki görünüşte yeniden
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => {
    if (e.isIntersecting && duzelt(e.target)) io.unobserve(e.target);
  }), { rootMargin: '300px 0px' }) : null;
  const izle = (svg) => {
    if (svg.dataset.ggBosluk || svg._ggIzle) return;
    svg._ggIzle = true;
    if (io) io.observe(svg); else duzelt(svg);
  };
  let bekliyor = false;
  const tara = () => { bekliyor = false; document.querySelectorAll(SEC).forEach(izle); };
  const iste = () => { if (!bekliyor) { bekliyor = true; requestAnimationFrame(tara); } };
  iste();
  // yalnız yeni öğe eklenince yeni çizim var mı diye bakılır (ölçüm yok, yalnız gözlemciye ekleme)
  new MutationObserver((ms) => { if (ms.some((m) => m.addedNodes.length)) iste(); }).observe(document.body, { childList: true, subtree: true });
})();

} catch (e) { console.error("gg-yayin: imza-bosluk.js", e); }

/* ==== kaydir-otomatik.js ==== */
try {
/* Aurum (22 Ekim 2026, sahibi: "aşağı inince otomatik kaymaya başlasın yavaş bir şekilde, müşteri dokunursa dursun, dokunduktan sonra
   kaydırmaz ve öyle bırakırsa tekrar kaymaya devam etsin"; sonra "biraz daha hızlı", "üstteki sağa, alttaki sola", "ürün bitmesin"):
   telefonda "Aynı seçkiden"in iki sırası (.aurum-kaydir__sira, aurum.css A20) ekrana gelince kendiliğinden kayar, saniyede 30 px:
   üst sıranın kartları sağa, alt sıranınki sola gider. Sıra bitmez: ProductGrid her sıranın arkasına kartların ikinci kopyasını koyar
   (.aurum-kaydir__kopya); konum bir takım genişliğini geçince fark edilmeden aynı görüntüye sarılır (parmakla kaydırınca da).
   Dokununca durur; kaydırmadan bırakılırsa 1,2 sn sonra, parmakla kaydırıldıysa 4 sn sonra kaldığı yerden sürer. Kendiliğinden kayma
   başlayınca kartlara oturma (scroll-snap) kapanır, sıra ekrandan çıkınca açılır. Ekran dışındayken ve sekme arka plandayken durur;
   hareket azaltma tercihinde hiç kaymaz. md ve üstünde çalışmaz.
   Akıcılık (sahibi: "kasıyor gibi"): tarayıcı scrollLeft'i tam piksele yuvarlar; tam kısım scrollLeft'e, kesir kısmı kartlara alt piksel
   kaydırma (transform) olarak verilir. */
(() => {
  const HIZ = 30, BEKLE_DOKUN = 1200, BEKLE_KAYDIR = 4000;
  const telefon = matchMedia('(max-width: 767.98px)');
  const azalt = matchMedia('(prefers-reduced-motion: reduce)');
  const kurulu = new WeakSet();

  const kur = (ul) => {
    if (kurulu.has(ul)) return;
    kurulu.add(ul);
    // üst sıra (ilk) kartları sağa götürür: scrollLeft azalır; alt sıra sola: scrollLeft artar
    const yon = [...ul.parentElement.children].filter((x) => x.classList.contains('aurum-kaydir__sira')).indexOf(ul) === 0 ? -1 : 1;
    const d = { gorunur: false, dokunuyor: false, bekleme: 0, son: 0, konum: 0, x0: 0, kaydirdi: false, basladi: false };
    const calisabilir = () => telefon.matches && !azalt.matches && d.gorunur && !d.dokunuyor && !document.hidden && performance.now() >= d.bekleme;
    const snap = (acik) => { ul.style.scrollSnapType = acik ? '' : 'none'; };
    // bir takımın genişliği: ilk kopya kartın ilk karta uzaklığı. Hız (26 Ekim 2026, sahibi: "detail kısmındaki kutucuklar açılırken
    // donuyor"): eskiden her karede, sıralar ekranda değilken bile ölçülüyordu; sayfada bir şey açılıp kapanırken her kare bütün sayfanın
    // yerleşimini zorla hesaplatıyordu (telefon hızında kare başına ~70 ms). Artık sıra ekrana yaklaşınca ve boyu değişince bir kez ölçülür;
    // kayma döngüsü yalnız sıra ekrandayken döner.
    let w = 0;
    const takim = () => {
      const k = ul.querySelector('.aurum-kaydir__kopya');
      w = k && k.offsetParent ? k.offsetLeft - ul.children[0].offsetLeft : 0;
      return w;
    };
    let kesirli = false;
    const kesir = (px) => {
      if (!px && !kesirli) return;
      kesirli = !!px;
      for (const li of ul.children) {
        li.style.transform = px ? `translate3d(${-px}px,0,0)` : '';
        li.style.willChange = px ? 'transform' : '';
      }
    };
    // sıra ekrana yaklaşınca (ekrana gelmeden): ölçüm ve üst sıranın başlangıç konumu
    let sigmaz = true;
    const hazirla = () => {
      if (!telefon.matches) return;
      takim();
      sigmaz = w <= 0 || ul.scrollWidth - ul.clientWidth <= w;
      if (sigmaz || d.basladi) return;
      d.basladi = true;   // üst sıra kopyanın başından başlar ki sağa doğru kayacak yeri olsun
      d.konum = yon < 0 ? w : 0;
      ul.scrollLeft = d.konum;
    };
    let donuyor = false;
    const baslat = () => {
      if (donuyor || !d.gorunur || !telefon.matches || document.hidden) return;
      donuyor = true;
      d.son = 0;
      requestAnimationFrame(adim);
    };
    const adim = (t) => {
      if (!d.gorunur || !telefon.matches || document.hidden) { donuyor = false; kesir(0); return; }   // döngü durur; ekrana gelince yeniden
      requestAnimationFrame(adim);
      const dt = d.son ? Math.min(64, t - d.son) : 0;
      d.son = t;
      if (sigmaz) return;
      if (!d.dokunuyor && !kesirli && (ul.scrollLeft < 1 || ul.scrollLeft > w + 1)) {
        // parmakla bir uca kadar kaydırıldıysa aynı görüntüye sar (kopya aynı kartlar)
        ul.scrollLeft = ul.scrollLeft < 1 ? ul.scrollLeft + w : ul.scrollLeft - w;
        d.konum = ul.scrollLeft;
      }
      if (!calisabilir()) { kesir(0); return; }
      snap(false);
      if (Math.abs(ul.scrollLeft - Math.floor(d.konum)) > 2) d.konum = ul.scrollLeft;   // başka bir şey kaydırdıysa oradan sür
      d.konum += (yon * HIZ * dt) / 1000;
      if (d.konum < 0.5) d.konum += w;
      else if (d.konum > w + 0.5) d.konum -= w;
      const tam = Math.floor(d.konum);
      ul.scrollLeft = tam;
      kesir(d.konum - tam);
    };
    new IntersectionObserver((g) => { if (g[0].isIntersecting) hazirla(); }, { rootMargin: '600px 0px' }).observe(ul);
    if ('ResizeObserver' in window) new ResizeObserver(() => { if (d.basladi || d.gorunur) hazirla(); }).observe(ul);
    document.addEventListener('visibilitychange', baslat);
    telefon.addEventListener?.('change', () => { hazirla(); baslat(); });

    // 30 Ekim 2026 (sahibi: "web siteyi aşağıya doğru kaydırırken onların üzerine dokunsam bile dursun istemiyorum, sadece sağa sola
    // hareket yaparsam kaysın"): dokununca yalnız parmağın altında durur (dokunup ürüne gitmek için); parmak aşağı-yukarı giderse hemen
    // yeniden kayar ve bırakınca beklemez. Yalnız yana kaydırmada durur ve bırakınca 4 sn bekler.
    ul.addEventListener('touchstart', (e) => {
      d.dokunuyor = true; d.kaydirdi = false; d.dikey = false; d.x0 = e.touches[0].clientX; d.y0 = e.touches[0].clientY; kesir(0);   // oturma kapalı kalır: açılsa sıra bir önceki karta zıplardı
    }, { passive: true });
    ul.addEventListener('touchmove', (e) => {
      if (d.kaydirdi || d.dikey) return;
      const dx = Math.abs(e.touches[0].clientX - d.x0), dy = Math.abs(e.touches[0].clientY - d.y0);
      if (dx < 8 && dy < 8) return;
      if (dx > dy) d.kaydirdi = true;
      else { d.dikey = true; d.dokunuyor = false; d.bekleme = 0; d.konum = ul.scrollLeft; }   // sayfa kaydırılıyor: sıra durmadan sürer
    }, { passive: true });
    const birak = () => {
      if (!d.dokunuyor) return;
      d.dokunuyor = false;
      d.bekleme = d.kaydirdi ? performance.now() + BEKLE_KAYDIR : 0;
      setTimeout(() => { d.konum = ul.scrollLeft; }, d.kaydirdi ? 900 : 0);   // parmakla atılan kayma bitince yeni konum
    };
    ul.addEventListener('touchend', birak, { passive: true });
    ul.addEventListener('touchcancel', birak, { passive: true });

    new IntersectionObserver((g) => {
      d.gorunur = g[0].isIntersecting;
      if (d.gorunur) { hazirla(); d.konum = ul.scrollLeft; baslat(); }
      else snap(true);
    }, { threshold: 0.4 }).observe(ul);
  };

  const tara = () => document.querySelectorAll('.aurum-kaydir__sira').forEach(kur);
  tara();
  // ada (React) sayfa aşağı inildiğinde kurulur: sıralar gelince bağlan (taramalar kare başına bire indirilir, bulununca durur)
  let bekleyen = 0;
  const mo = new MutationObserver(() => {
    if (bekleyen) return;
    bekleyen = requestAnimationFrame(() => {
      bekleyen = 0;
      tara();
      // 28 Ekim 2026: ana sayfada iki bölüm (dört sıra) ayrı ayrı kurulur; ürün sayfasında iki sıra bulununca gözlem biter
      if (!document.querySelector('.aurum-kaydir--tel') && document.querySelectorAll('.aurum-kaydir__sira').length >= 2) mo.disconnect();
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

} catch (e) { console.error("gg-yayin: kaydir-otomatik.js", e); }

/* ==== kaydir-surukle.js ==== */
try {
/* Aurum (22 Ekim 2026): "Aynı seçkiden" önerileri yana kaydırılabiliyor (aurum.css A20); bilgisayarda fareyle tutup sola/sağa
   çekerek de kaydırılsın (sahibi: "mouse'la sola çekip kaydırmak istiyorum"). Yalnız fare; dokunmatik zaten kendiliğinden kayar.
   Sürüklerken tıklama (ürüne gitme) yutulur, bırakınca en yakın karta yumuşakça oturur. */
(() => {
  // bilgisayarda iki sıranın kabı (.aurum-kaydir), telefonda her sıra (.aurum-kaydir__sira) kendi başına kayar
  const SECICI = '.aurum-kaydir, .aurum-kaydir > .aurum-kaydir__sira';   // ana sayfanın sıraları da (--tel, 28 Ekim 2026: bilgisayarda da şerit)
  let s = null;
  document.addEventListener('pointerdown', (e) => {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    let ul = e.target.closest && e.target.closest(SECICI);
    while (ul && ul.scrollWidth <= ul.clientWidth + 2) ul = ul.parentElement && ul.parentElement.closest(SECICI);
    if (!ul) return;
    s = { ul, x: e.clientX, sol: ul.scrollLeft, kaydi: false };
  });
  document.addEventListener('pointermove', (e) => {
    if (!s) return;
    const dx = e.clientX - s.x;
    if (!s.kaydi && Math.abs(dx) < 6) return;
    if (!s.kaydi) {
      s.kaydi = true;
      s.ul.style.scrollSnapType = 'none';
      s.ul.style.cursor = 'grabbing';
      s.ul.style.userSelect = 'none';
    }
    s.ul.scrollLeft = s.sol - dx;
    e.preventDefault();
  });
  const bitir = () => {
    if (!s) return;
    const { ul, kaydi } = s;
    s = null;
    if (!kaydi) return;
    ul.style.cursor = '';
    ul.style.userSelect = '';
    // en yakın karta otur, sonra yapışmayı geri aç
    const li = ul.classList.contains('aurum-kaydir') ? ul.firstElementChild : ul.querySelector('li');
    const adim = li ? li.getBoundingClientRect().width + parseFloat(getComputedStyle(ul).columnGap || 0) : 0;
    const hedef = adim ? Math.round(ul.scrollLeft / adim) * adim : ul.scrollLeft;
    const az = matchMedia('(prefers-reduced-motion: reduce)').matches;
    ul.scrollTo({ left: hedef, behavior: az ? 'auto' : 'smooth' });
    setTimeout(() => { ul.style.scrollSnapType = ''; }, az ? 0 : 400);
    // sürüklemenin sonundaki tıklama ürün sayfasını açmasın
    const yut = (ev) => { ev.preventDefault(); ev.stopPropagation(); };
    ul.addEventListener('click', yut, { capture: true, once: true });
    setTimeout(() => ul.removeEventListener('click', yut, { capture: true }), 0);
  };
  document.addEventListener('pointerup', bitir);
  document.addEventListener('pointercancel', bitir);
  // sürüklerken bağlantı ve görsel sürükleme hayaleti çıkmasın
  document.addEventListener('dragstart', (e) => { if (e.target.closest && e.target.closest(SECICI)) e.preventDefault(); });
})();

} catch (e) { console.error("gg-yayin: kaydir-surukle.js", e); }

/* ==== sayfa-animasyon.js ==== */
try {
/* 58) Bütün sayfalar · ana sayfanın animasyonları (önizleme, 9 Ekim).
   Sahibi: "ana sayfada bulunan aşağı kaydırdıkça çıkan yazı animasyonlarını, diğer animasyonları da diğer sayfalara aynı şekilde yapmanı istiyorum"
   ve "ürün ad yazılarındaki parlama efekti yok".
   Ana sayfa dışındaki her sayfada (ürün, koleksiyon, bilgi ve yasal sayfalar, iletişim / randevu / garanti, arama, sepet, 404) ana-v1.js'in onaylı
   animasyonları aynen, onun ortak parçasıyla (window.ggAna; ölçüler orada, tek yerden):
   - Yazılar TEK animasyonla (21st Blur Reveal, tom_ui): kelime kelime bulanıktan nete, hafifçe yukarı; 0,6 sn, kelime arası 0,06 sn; ekrana girince
     bir kez, aynı anda girenler 0,12 sn arayla. 20 kelimeden uzun paragraflarda kelime arası kısalır (paragraf en geç ~1,8 sn'de tamamlanır).
   - Altın yazılar (başlıklar, altın etiketler, fiyatlar) kelime kelime, yazının kendi altın ışığıyla; ışık bütün yazıya yayılan tek geçiş gibi.
   - Her bölüm başlığının üstünde satranç taşı ve iki yanında kendini çizen ince altın çizgi; taşlar sayfa aşağı indikçe değer kazanır
     (piyon → at → fil → kale → vezir; sayfa başlığı piyonla başlar). Ürün sayfasında İncelikle başlığı da bu sıraya girer.
   - Ürün adlarında ışıltı: el yazısı ad yazılırken her çizgi altın ışıkla parlayıp sakinleşir — ürün sayfasının başlığı (dört ürünün hepsi) ve
     ürün kartları. Eskiden yalnız Yakut'un sayfasında vardı (yakut-yazi-isik.js, kaydedilenler/arsiv/'e kaldırıldı).
   - Fotoğraflar (Atölye'nin adım fotoğrafları, koleksiyondaki Oyna / Sergile kartları) ekrana girerken aşağıdan yükselir (İncelikle kartlarıyla aynı hareket).
   Dokunulmayanlar: düğmeler, formlar, takvim, açılır "Ayrıntılar" içerikleri, alttaki sabit satın alma çubuğu, sepet ve arama sonuçları (değişen yazılar),
   kayan şerit (Hakkımızda'daki usta kartları), sitenin kendi kaydırma sahnesi (Elden ele galerisi), sayılar (Hakkımızda), İncelikle'nin yazıları
   (kendi animasyonu var, yalnız başlığına taş eklenir). Hareket azaltma açıksa hiçbir şey hareket etmez (yazılar, taşlar, çizgiler sabit ve tam görünür). */
(() => {
  if ((window.ggDil ? window.ggDil.yol : location.pathname) === '/') return;   // ana sayfa (dil önekli de): ana-v1.js
  const A = window.ggAna;
  const main = document.querySelector('main');
  if (!A || !main) return;
  const { words, arm, piece, line, glow, RM } = A;
  document.documentElement.classList.add('gg-sa');

  const S = 'html.gg-sa';
  const css = document.createElement('style');
  css.id = 'gg-sayfa-animasyon-css';
  css.textContent = `
/* adacık çizilene kadar yazılar görünüp kaybolmasın: çizilince tek animasyonla gelir (bölüm ekrana yaklaştıktan 6 sn sonra her durumda görünür) */
${S}.v1-m .sa-pend :is(h1,h2,h3,h4,p,dt,dd,blockquote,figcaption):not(:is(button,form,nav,[role="region"]) *){opacity:0}
/* Aurum 25 Ekim 2026 (hız): ürün kartları da li; bütün kartı gizlemek fotoğrafları da adacık açılana kadar (yavaş telefonda ~4 sn)
   saklıyordu. Fotoğraflı li görünür kalır, içindeki ad ve fiyat yine yukarıdaki kuralla gizli başlar. */
${S}.v1-m .sa-pend li:not(:has(img,picture)):not(:is(button,form,nav,[role="region"]) *){opacity:0}
/* fotoğraflar: aşağıdan yükselerek (İncelikle kartlarıyla aynı: 1,1 sn, yumuşak duruş; aynı anda girenler 0,09 sn arayla) */
${S}.v1-m .sa-yk{opacity:0;translate:0 var(--sa-y,64px);transition:opacity 1100ms cubic-bezier(.33,1,.68,1),translate 1100ms cubic-bezier(.33,1,.68,1);transition-delay:var(--sa-g,0ms)}
${S}.v1-m .sa-yk.sa-in{opacity:1;translate:0 0}
`;
  document.head.appendChild(css);

  const TASLAR = ['piyon', 'at', 'fil', 'kale', 'vezir'];
  const ELYAZI = 'svg[stroke-width="44"]';
  const BLOK = 'h1, h2, h3, h4, p, li, dt, dd, blockquote, figcaption';
  // BLOK olmayan ama tek başına canlanan satırlar: ürün kartı fiyatı, Oyna / Sergile alt satırı
  const EK = '[data-slot="product-card-metric"], .gg-onz-stack .sh > span';
  // yazısına dokunulmayan yerler
  const ATLA = 'button, nav, form, label, select, textarea, [role="region"], [role="dialog"], [role="grid"], [aria-live], [contenteditable], .fixed,'
    + ' .sr-only, [class*="animate-marquee"], .gg-award-wrap, [data-aurum-fiyat], [data-island="Stats"], .v1-t, .gi-t, .v1-kick, .v1-ggt, #gg-incelikle';
  // içinde düğme ya da form alanı olan yazılara da dokunulmaz (ör. "Ayrıntılar" başlıklarının içindeki aç / kapa düğmesi)
  const ETKIN = 'button, input, select, textarea, [role="button"]';
  // içerikleri kullanıcıyla değişen adacıklar: yalnız sayfa başlığı canlanır
  const KISITLI = '[data-island="Search"], [data-island="Cart"]';
  // ışıltı: ürün sayfasının başlığı ve ürün kartlarının adları (arama ve sepetteki kartlar hariç)
  const ISIK = '.gg-main-product h1 > svg, [data-slot="product-card-title"] a > svg';
  // aşağıdan yükselen fotoğraflar
  const FOTO = '[data-island="Timeline"] img, [data-island="PromoTiles"] img';

  /* ---- yardımcılar ---- */
  const hiza = (h) => (getComputedStyle(h).textAlign === 'center' ? 'center' : 'start');
  // yazının kendi altını: geçişi döndürür; düz yazıda null; rengi saydam ama altını kendinde olmayan yazıda false (dokunulmaz, görünmez kalırdı)
  const altin = (el) => {
    const cs = getComputedStyle(el);
    if ((cs.backgroundClip === 'text' || cs.webkitBackgroundClip === 'text') && cs.backgroundImage && cs.backgroundImage !== 'none') return cs.backgroundImage;
    const dolgu = cs.webkitTextFillColor || cs.color;
    return /^rgba\(.*,\s*0\)$|^transparent$/.test(dolgu) ? false : null;
  };
  // açılır kapanır bir panelin içinde mi (aç / kapa düğmesinden hemen sonra gelen kutu): açılırken kelime animasyonu olmaz
  const panelde = (el, sec) => {
    for (let a = el.parentElement; a && a !== sec; a = a.parentElement) {
      const o = a.previousElementSibling;
      if (o && (o.matches('[aria-expanded]') || o.querySelector(':scope > [aria-expanded]'))) return true;
    }
    return false;
  };
  // palet.css 182: sınıfsız ara başlıklar (yasal ve bilgi sayfaları) başlık yazı tipini sınıfsız olmalarından alır; sınıf eklenince korunsun diye işaret
  const sinifsiz = (el) => { if (!el.hasAttribute('class')) el.setAttribute('data-gg-sinifsiz', ''); };
  // Hız (25 Ekim 2026, sahibi: "donma kasma olmasın"): okuma (planla: yazının altını, getComputedStyle) ile yazma (uygula: kelimelere
  // bölme) ayrı. Bir bölümdeki bütün yazılar önce okunur, sonra işlenir; eskiden her yazıda okuyup hemen yazmak, sonraki okumada
  // bütün sayfanın stilini yeniden hesaplatıyordu (koleksiyon sayfasında, telefon hızında 1,7 sn). Sonuç aynı.
  const planla = (el) => {
    let g = altin(el);
    if (g === false) {
      // altını bir üst öğeden geliyorsa (ör. ürün sayfasındaki fiyat): yazının tek sahibi o öğeyse onu işle, kelimeler aynı altını alır
      const ata = el.parentElement;
      if (!ata || ata.closest(ATLA) || ata.textContent.trim() !== el.textContent.trim()) return null;
      const ga = altin(ata);
      if (!ga) return null;
      el = ata; g = ga;
    }
    const n = (el.textContent || '').trim().split(/\s+/).filter(Boolean).length;
    return n ? { el, g, n } : null;
  };
  const uygula = ({ el, g, n }) => {
    sinifsiz(el);
    const opt = {};
    if (g) opt.gold = g;
    if (n > 20) opt.stagger = Math.max(12, 1200 / n);
    words(el, opt);
  };

  // bölüm başlığı: bölümdeki ilk h1/h2 (ürün kartı, akordeon, düğme içindekiler ve el yazısı adlar hariç). Ürün bilgisi bölümünün başlığı el yazısı ad: taş almaz.
  const baslikBul = (sec) => {
    if (sec.classList.contains('gg-main-product')) return null;
    for (const h of sec.querySelectorAll('h1, h2')) {
      if (h.closest('[data-slot="product-card"], [role="region"], button, nav, form, .fixed, [hidden]') || h.querySelector(ELYAZI)) continue;
      if (!h.offsetParent && !h.querySelector('.v1-kick')) continue;   // bu ekranda gizli kopya (ör. yalnız telefonda görünen)
      return h;
    }
    return null;
  };
  const kickler = [];
  const baslik = (h, tas) => {
    if (h.querySelector(':scope > .v1-kick')) return;
    const duz = !/flex|grid/.test(getComputedStyle(h).display);   // yan yana dizilen başlığa taş konmaz (yazının yanına düşerdi)
    if (!h.classList.contains('gi-t')) {   // İncelikle başlığının kelimeleri kendi animasyonunda; yalnız taş eklenir
      const g = altin(h);
      if (g === false) return;
      sinifsiz(h);
      words(h, { gold: g || undefined, start: duz ? 1 : 0, noArm: true });
    }
    if (duz) {
      const k = document.createElement('span');
      k.className = 'v1-kick';
      k.setAttribute('aria-hidden', 'true');
      k.dataset.al = hiza(h);
      k.dataset.tas = tas;
      k.append(line('l'), piece(tas), line('r'));
      h.prepend(k);
      kickler.push([h, k]);
    }
    h.classList.add('v1-t');
    arm(h);
  };
  // başlık hizası ekran döndürülünce / pencere değişince
  let rz = 0;
  addEventListener('resize', () => {
    if (rz) return;
    rz = requestAnimationFrame(() => {
      rz = 0;
      const al = kickler.map(([h]) => hiza(h));
      kickler.forEach(([, k], i) => { if (k.dataset.al !== al[i]) k.dataset.al = al[i]; });
    });
  });

  // fotoğraflar: ekrana girince aşağıdan yükselir (bir kez)
  const yio = !RM && 'IntersectionObserver' in window ? new IntersectionObserver((es) => {
    const vis = es.filter((e) => e.isIntersecting).map((e) => e.target)
      .sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1);
    vis.forEach((el, k) => { yio.unobserve(el); el.style.setProperty('--sa-g', (Math.min(k, 6) * 90) + 'ms'); el.classList.add('sa-in'); });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }) : null;
  const yukselt = (els) => {
    if (!yio) return;
    const yeni = els.filter((el) => !el.classList.contains('sa-yk'));
    const boy = yeni.map((el) => el.offsetHeight);   // önce hepsi okunur, sonra yazılır
    yeni.forEach((el, i) => {
      el.style.setProperty('--sa-y', Math.round(Math.min(100, Math.max(40, boy[i] * 0.35))) + 'px');
      el.classList.add('sa-yk');
      yio.observe(el);
    });
  };

  /* ---- taş sırası: sayfanın ilk hâlinden (adacıkların çizimden önceki iskeleti de başlığı taşır), başlığı olan bölümler yukarıdan aşağı ---- */
  const bolumler = [...main.querySelectorAll(':scope > .shopify-section')];
  const tasi = new Map();
  let sira = 0;
  const tasAl = (sec) => { if (!tasi.has(sec)) tasi.set(sec, TASLAR[Math.min(sira++, TASLAR.length - 1)]); return tasi.get(sec); };
  bolumler.forEach((sec) => { if (baslikBul(sec)) tasAl(sec); });

  /* ---- bir bölüm ---- */
  const isleBolum = (sec) => {
    const h = baslikBul(sec);
    if (h) baslik(h, tasAl(sec));
    if (sec.id === 'gg-incelikle' || sec.querySelector(KISITLI)) return;   // İncelikle, sepet, arama: yalnız başlık

    const plan = [];
    sec.querySelectorAll(BLOK + ', ' + EK + ', a').forEach((el) => {
      if (el.closest(ATLA) || el.querySelector(ELYAZI + ', ' + ETKIN) || panelde(el, sec)) return;
      if (el.tagName === 'A') { if (el.closest(BLOK) || el.querySelector(BLOK)) return; }   // tek başına duran bağlantı ("LIMITED EDITION" gibi)
      else if (el.querySelector(BLOK)) return;   // yalnız en içteki yazı blokları
      const p = planla(el);
      // işlenecek bir yazının içindeki ya da onu kapsayan ikinci yazı atlanır (eskiden ilki işlenince .v1-t olur, ikincisi ATLA'ya takılırdı)
      if (p && !plan.some((q) => q.el.contains(p.el) || p.el.contains(q.el))) plan.push(p);
    });
    plan.forEach(uygula);
    // Sıkça sorulan sorular: soruların yazısı (düğmenin içinde; ana sayfadaki "Sorularınız" gibi). Cevaplar açılırken sade gelir.
    sec.querySelectorAll('[data-island="Faq"] button[aria-expanded]').forEach((b) => {
      if (b.querySelector('.v1-qt')) return;
      const tw = document.createTreeWalker(b, NodeFilter.SHOW_TEXT, {
        acceptNode: (n) => (n.data.trim() && !n.parentElement.closest('svg, .sr-only') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP),
      });
      const t = tw.nextNode();
      if (!t) return;
      const s = document.createElement('span');   // sitenin kendi öğesine sınıf eklenmez; yazı kendi kutumuza alınır
      s.className = 'v1-qt';
      t.replaceWith(s);
      s.appendChild(t);
      words(s);
    });
    yukselt([...sec.querySelectorAll(FOTO)].map((img) => (img.closest('[data-island="PromoTiles"]') && img.parentElement) || img));
    // ürün adlarında ışıltı (katmanı olmayan çizimlere)
    sec.querySelectorAll('.v1-ggt').forEach((ov) => { if (!ov._src || !ov._src.isConnected || ov._src.nextElementSibling !== ov) ov.remove(); });
    sec.querySelectorAll(ISIK).forEach((svg) => {
      const ov = svg.nextElementSibling;
      if (ov && ov.classList.contains('v1-ggt') && ov._src === svg) return;
      glow(svg);
    });
  };

  /* ---- çalıştırma: düz bölümler hemen; adacıklı bölümler adacık çizilince, ilk boyamadan önceki karede (React yeniden çizerse yeniden) ---- */
  const guvenlik = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return;
    guvenlik.unobserve(e.target);
    setTimeout(() => e.target.classList.remove('sa-pend'), 6000);
  }), { rootMargin: '600px 0px' }) : null;
  const bizim = (n) => n.nodeType !== 1 || n.matches('.v1-wd, .v1-kick, .v1-ggt, .v1-qt');   // kendi eklediklerimiz (yeniden tarama gerektirmez)

  bolumler.forEach((sec) => {
    if (!sec.querySelector('.gg-island')) { try { isleBolum(sec); } catch (e) { /* bölümün kendi görünüşü kalır */ } return; }
    if (!RM) sec.classList.add('sa-pend');
    let plan = 0;
    const calis = () => {
      plan = 0;
      if (![...sec.querySelectorAll('.gg-island')].every((a) => a.hasAttribute('data-mounted'))) return;
      try { isleBolum(sec); } catch (e) { /* bölümün kendi görünüşü kalır */ }
      sec.classList.remove('sa-pend');
    };
    const iste = () => { if (!plan) plan = requestAnimationFrame(calis); };
    new MutationObserver((ms) => {
      if (ms.some((m) => m.type === 'attributes' || [...m.addedNodes].some((n) => !bizim(n)))) iste();
    }).observe(sec, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-mounted'] });
    iste();
    if (guvenlik) guvenlik.observe(sec); else setTimeout(() => sec.classList.remove('sa-pend'), 6000);
  });

  // politika sayfaları (/policies/…): Shopify başlığı bölüm dışında verir; öteki sayfaların başlığı gibi taşlı altın başlık (29 Ekim 2026, sahibi: "evet")
  const politika = main.querySelector(':scope > .shopify-policy__container .shopify-policy__title h1');
  if (politika) { try { baslik(politika, TASLAR[0]); } catch (e) { /* düz başlık kalır */ } }
})();

} catch (e) { console.error("gg-yayin: sayfa-animasyon.js", e); }

/* ==== sepet-odeme.js ==== */
try {
/* 31–32) Sepet sayfası ve sepet paneli: ödeme logoları footer'daki onaylı altın logolarla aynı (madde 7–9: çerçevesiz altın, tek satır, telefonda 5 logo).
   Sepetin kendi listesi gizlenir, yanına footer listesinin bir kopyası konur; sepet yeniden çizilirse kopya yeniden eklenir.
   Yayında: sepet bileşeni footer'daki ödeme logosu parçasını (gg-pay-glyph) kullanacak; bu betik yayına gitmez. */
(() => {
  const sync = () => {
    // listenin adı sayfanın dilinde (aa-dil.js · secici.odeme_yontemleri) — 9 Ekim: eskiden yalnız Türkçe sayfada çalışıyordu
    const ad = window.ggDil ? window.ggDil.t('secici.odeme_yontemleri', null, 'Ödeme yöntemleri') : 'Ödeme yöntemleri';
    const footLi = document.querySelector('footer li.gg-pay-chip');   // dil bağımsız: logoların listesi (adı her dilde başka)
    const footUl = (footLi && footLi.closest('ul')) || document.querySelector('footer ul[aria-label="' + ad.replace(/"/g, '\\"') + '"]');
    if (!footUl) return;
    // sepet sayfası ve sepet paneli: ikisinde de aynı liste
    document.querySelectorAll('.gg-glass-capsule ul.mt-3.flex.flex-wrap:not(.gg-sepet-odeme)').forEach((cartUl) => {
      if (!cartUl.classList.contains('gg-sepet-gizli')) cartUl.classList.add('gg-sepet-gizli');
      if (cartUl.nextElementSibling && cartUl.nextElementSibling.classList.contains('gg-sepet-odeme')) return;
      const copy = footUl.cloneNode(true);
      copy.classList.add('gg-sepet-odeme');
      copy.removeAttribute('id');
      cartUl.after(copy);
    });
  };
  sync();
  new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
})();

} catch (e) { console.error("gg-yayin: sepet-odeme.js", e); }

/* ==== zz-ana-sayfa-kaide.js ==== */
try {
/* Ana sayfa üst görsel (slider) · Aurum Galerie (21 Ekim 2026). GG Chess'in "kaide" düzeni (zz-ana-sayfa-kaide.js, 9 Ekim: geniş ekranda
   arkada bulanık kopya, sağda net dikey fotoğraf; GG hâli _gg-asil/zz-ana-sayfa-kaide.js) genelleştirildi:
   - GG'de dört ürünün sabit kaide görselleri vardı; Aurum'da her slayt kendi görselini kullanır (bölüm ayarındaki görsel).
   - Heykel fotoğrafları çoğunlukla kare ya da dikey. Geniş ya da yatay ekranda görsel kartı tam doldursaydı heykelin başı ve kaidesi
     kesilirdi; bunun yerine görselin bulanık kopyası arkada, kendisi sağda net, kendi en/boy oranıyla (yükseklik kartın yüksekliğinden,
     ölçü ve köşeler palet.css 38b/38c, oran aurum.css). Net kare her slaytın kendi katmanında durur, slaytla birlikte yumuşakça geçer.
   - Telefonda ve dikey tablette görsel kartı doldurur (aurum.css: kart 4:5).
   Hareket yok; yalnız yerleşim. Görsel yoksa (slaytta görsel seçilmemişse) hiçbir şey eklenmez. */
(() => {
  const css = document.createElement('style');
  css.textContent =
    '.gg-kaide-net{display:none}' +
    '@media (min-width:1024px),(min-width:768px) and (orientation:landscape){' +
    '[data-island="HomeSlider"] div.relative.h-full.overflow-hidden > picture img{filter:blur(28px) brightness(.55) saturate(1.1);transform:scale(1.12)}' +
    '.gg-kaide-net{display:block;position:absolute;z-index:2;top:0;inset-inline-end:max(4vw,calc((100vw - 80rem)/2 + 2.5rem));' +
    'height:100%;width:calc(max(100svh,600px)*var(--gg-oran,1));background:center/cover no-repeat;pointer-events:none}' +
    '}';
  document.head.appendChild(css);

  const enBuyuk = (img) => {
    // srcset'teki en geniş kaynak (net kare büyük ekranda keskin görünsün); yoksa src
    const set = (img.getAttribute('srcset') || '').split(',').map((x) => x.trim().split(/\s+/)).filter((x) => x[0]);
    let best = null, bw = 0;
    set.forEach(([u, w]) => { const n = parseInt(w, 10) || 0; if (n > bw) { bw = n; best = u; } });
    return best || img.currentSrc || img.getAttribute('src') || '';
  };

  const yerlestir = () => {
    document.querySelectorAll('[data-island="HomeSlider"] div.relative.h-full.overflow-hidden').forEach((ic) => {
      const img = ic.querySelector(':scope > picture img');
      let net = ic.querySelector(':scope > .gg-kaide-net');
      if (!img) { if (net) net.remove(); ic.style.removeProperty('--gg-oran'); return; }
      if (!net) { net = document.createElement('div'); net.className = 'gg-kaide-net'; net.setAttribute('aria-hidden', 'true'); ic.appendChild(net); }
      const w = parseFloat(img.getAttribute('width')) || img.naturalWidth || 1;
      const h = parseFloat(img.getAttribute('height')) || img.naturalHeight || 1;
      const oran = Math.min(1, Math.max(0.5625, w / h)).toFixed(4);   // en geniş kare, en dar 9:16
      // oran kartın kendisine yazılır: net görsel de soldaki yazı sütunu da (aurum.css A2b) aynı değeri kullanır
      if (ic.style.getPropertyValue('--gg-oran') !== oran) ic.style.setProperty('--gg-oran', oran);
      const bg = "url('" + enBuyuk(img).replace(/'/g, '%27') + "')";
      if (net.style.backgroundImage !== bg) net.style.backgroundImage = bg;
    });
  };
  let bekle = false;
  const iste = () => { if (!bekle) { bekle = true; queueMicrotask(() => { bekle = false; yerlestir(); }); } };
  iste();
  new MutationObserver(iste).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
})();

} catch (e) { console.error("gg-yayin: zz-ana-sayfa-kaide.js", e); }
